(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42186],{

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/benefits/icons/reassurance.tsx


function Reassurance() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4F96F6",
                d: "M38.656 17.624h-4.609v-5.315H4.541v21.486h4.991c.168-.526.336-1.16.635-1.675h-3.95V13.985H32.37V32.12H18.905c.383.478.67 1.065.862 1.675h14.292v-2.01-12.486h4.597a4.64 4.64 0 013.112 1.198h-4.19v6.344h5.746v5.279h-.706c.024.047.06.083.084.131.323.491.622 1.006.85 1.544H45v-9.827c0-3.495-2.849-6.344-6.344-6.344zm.598 7.54v-2.992h3.711c.228.55.36 1.161.36 1.796v1.197h-4.07z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4F96F6",
                d: "M14.452 30.552a4.082 4.082 0 00-4.07 4.07 4.082 4.082 0 004.07 4.07 4.082 4.082 0 004.07-4.07 4.082 4.082 0 00-4.07-4.07zm0 6.463a2.401 2.401 0 01-2.394-2.394 2.401 2.401 0 012.394-2.394 2.401 2.401 0 012.394 2.394 2.401 2.401 0 01-2.394 2.394z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4F96F6",
                d: "M14.452 36.285a1.664 1.664 0 100-3.328 1.664 1.664 0 000 3.328zM38.428 30.552a4.082 4.082 0 00-4.07 4.07 4.082 4.082 0 004.07 4.07 4.082 4.082 0 004.07-4.07 4.082 4.082 0 00-4.07-4.07zm0 6.463a2.401 2.401 0 01-2.393-2.394 2.401 2.401 0 012.394-2.394 2.401 2.401 0 012.394 2.394 2.401 2.401 0 01-2.395 2.394z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4F96F6",
                d: "M38.428 36.285a1.664 1.664 0 100-3.328 1.664 1.664 0 000 3.328zM19.623 28.995a6.708 6.708 0 006.704-6.703 6.708 6.708 0 00-6.704-6.703 6.708 6.708 0 00-6.703 6.703 6.708 6.708 0 006.704 6.703zm0-11.73a5.027 5.027 0 110 10.054 5.027 5.027 0 110-10.054z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4F96F6",
                d: "M22.831 20.735l-1.389-.957-2.334 3.411-1.556-1.4-1.125 1.245 2.993 2.67 3.411-4.969z"
            })
        ]
    });
}
/* harmony default export */ var reassurance = (Reassurance);

;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/benefits/icons/financialSecurity.tsx


function FinancialSecurity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_932",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4F96F6",
                    d: "M0 0H50V50H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_932)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4F96F6",
                    d: "M21.384 4.104c-3.62 0-6.665 2.676-6.665 6.189v8.093c-1.85 0-3.332 1.56-3.332 3.422v20.755c0 1.862 1.483 3.437 3.332 3.437h20.948C37.517 46 39 44.425 39 42.563V21.808c0-1.861-1.483-3.422-3.333-3.422v-8.093c0-3.513-3.045-6.19-6.665-6.19h-7.617zm0 1.904h7.618c2.71 0 4.761 1.863 4.761 4.285v8.093h-1.904v-5.713c0-2.594-1.84-4.76-4.285-4.76h-4.761c-2.445 0-4.285 2.166-4.285 4.76v5.713h-1.904v-8.093c0-2.422 2.05-4.285 4.76-4.285zm1.429 3.809h4.76c1.354 0 2.381 1.098 2.381 2.856v5.713h-9.522v-5.713c0-1.758 1.027-2.856 2.38-2.856zM14.719 20.29h20.948c.788 0 1.429.64 1.429 1.517v20.755c0 .878-.64 1.533-1.429 1.533H14.72c-.788 0-1.428-.655-1.428-1.533V21.808c0-.877.64-1.517 1.428-1.517zm10.474 1.904c-5.51 0-9.998 4.488-9.998 9.998 0 5.51 4.488 9.998 9.998 9.998 5.51 0 9.998-4.487 9.998-9.998 0-5.51-4.487-9.998-9.998-9.998zm0 1.905a8.08 8.08 0 018.094 8.093 8.08 8.08 0 01-8.094 8.094 8.08 8.08 0 01-8.093-8.094 8.08 8.08 0 018.093-8.093zm-.104 1.89a.952.952 0 00-.848.966v.52a2.877 2.877 0 00-2.38 2.813c0 1.623 1.52 2.856 3.332 2.856 1.062 0 1.429.465 1.429.953 0 .614-.24.952-.953.952h-2.856a.953.953 0 100 1.904h1.428v.476a.951.951 0 101.904 0v-.52a2.878 2.878 0 002.381-2.812c0-1.623-1.52-2.857-3.333-2.857-1.061 0-1.428-.465-1.428-.952 0-.615.24-.952.952-.952h2.857a.955.955 0 00.965-.953.951.951 0 00-.965-.952h-1.429v-.476a.954.954 0 00-1.056-.967z"
                })
            })
        ]
    });
}
/* harmony default export */ var financialSecurity = (FinancialSecurity);

;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/benefits/icons/convenience.tsx


function Convenience() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_896",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4F96F6",
                    d: "M0 0H50V50H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#4F96F6",
                mask: "url(#mask0_0_896)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M37.785 47H12.141A3.145 3.145 0 019 43.858V9.701a3.317 3.317 0 013.318-3.308h6.067a.916.916 0 110 1.833h-6.068c-.818 0-1.484.662-1.484 1.475v34.157a1.31 1.31 0 001.308 1.309h25.644a1.31 1.31 0 001.308-1.309V9.701c0-.813-.666-1.475-1.484-1.475h-6.068a.916.916 0 110-1.833h6.068A3.317 3.317 0 0140.926 9.7v34.157A3.145 3.145 0 0137.786 47z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M37.785 47H12.141A3.145 3.145 0 019 43.858V9.701a3.317 3.317 0 013.318-3.308h6.067a.916.916 0 110 1.833h-6.068c-.818 0-1.484.662-1.484 1.475v34.157a1.31 1.31 0 001.308 1.309h25.644a1.31 1.31 0 001.308-1.309V9.701c0-.813-.666-1.475-1.484-1.475h-6.068a.916.916 0 110-1.833h6.068A3.317 3.317 0 0140.926 9.7v34.157A3.145 3.145 0 0137.786 47z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33.883 11.613h-17.84a.917.917 0 01-.753-1.439l4.69-6.779A.916.916 0 0120.732 3h8.46c.3 0 .582.148.753.395l4.691 6.78a.915.915 0 01-.754 1.438zm-16.09-1.834h14.341l-3.422-4.946h-7.498L17.793 9.78zM36.221 29.77H23.23a.916.916 0 110-1.834H36.22a.916.916 0 110 1.834zM36.221 19.059H23.23a.916.916 0 110-1.834H36.22a.916.916 0 110 1.834zM36.221 40.73H23.23a.916.916 0 110-1.834H36.22a.916.916 0 110 1.834zM17.155 21.422a3.284 3.284 0 01-3.28-3.28 3.284 3.284 0 013.28-3.28 3.284 3.284 0 013.28 3.28 3.284 3.284 0 01-3.28 3.28zm0-4.727c-.797 0-1.446.65-1.446 1.447 0 .798.649 1.447 1.446 1.447.798 0 1.447-.649 1.447-1.447s-.65-1.447-1.447-1.447zM17.155 32.133a3.284 3.284 0 01-3.28-3.28 3.284 3.284 0 013.28-3.28 3.284 3.284 0 013.28 3.28 3.284 3.284 0 01-3.28 3.28zm0-4.726c-.797 0-1.446.649-1.446 1.446 0 .798.649 1.447 1.446 1.447.798 0 1.447-.65 1.447-1.447s-.65-1.446-1.447-1.446zM16.14 42.99a.913.913 0 01-.648-.268l-2.435-2.435a.916.916 0 111.296-1.296l1.787 1.787 3.876-3.875a.916.916 0 111.296 1.296l-4.524 4.523a.913.913 0 01-.648.269z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.964 8.227a.916.916 0 01-.348-.073.766.766 0 01-.303-.202 1.099 1.099 0 01-.201-.293.89.89 0 01-.065-.349c0-.128.018-.238.065-.357.054-.11.119-.211.201-.294a.96.96 0 011.302 0 .948.948 0 01.265.651.925.925 0 01-.265.642.93.93 0 01-.303.202.916.916 0 01-.348.073z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var convenience = (Convenience);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/benefits/style.module.scss
var style_module = __webpack_require__(82259);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/benefits/index.tsx







const whyUsList = [
    {
        title: "Reassurance:",
        description: "Extended warranties provide consumers with the confidence that unforeseen repair expenses will be taken care of, offering them a sense of protection.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(reassurance, {})
    },
    {
        title: "Financial Security:",
        description: "Depending on the type and level of coverage provided, extended warranties can provide significant financial security in case of a breakdown or malfunction.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(financialSecurity, {})
    },
    {
        title: "Convenience:",
        description: "Repair services are usually fast and reliable for products under an extended warranty, so no time is wasted.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(convenience, {})
    }, 
];
function Benefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: whyUsList,
        mainTitle: "The Benefits Extended Warranties Provide Include the Following:",
        colors: {
            titleColor: "#4F96F6"
        },
        classes: {
            mainTitleClasses: "font-bold lg:text-3xl text-xl lg:leading-[45px]",
            innerSectionClasses: "flex flex-wrap mt-[40px] gap-[34px]",
            oneBoxClasses: `  w-[360px] sm:h-[329px] ${(style_module_default()).oneBoxStyle} py-[30px] sm:pt-[42px] sm:px-[32px] px-[15px] mx-auto lg:mx-0`,
            iconClasses: " ",
            titleClasses: "lg:text-lg  text-base lg:leading-8 font-bold mt-[10px]",
            descriptionClasses: "font-light text-sm lg:text-base   lg:leading-6 mt-[13px]"
        }
    });
}


/***/ }),

/***/ 2586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/mainBanner/styles.module.scss
var styles_module = __webpack_require__(83083);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/shared/s3Icon/index.tsx
var s3Icon = __webpack_require__(65984);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/mainBanner/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 561 375",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_175)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M440.366 112.508s-15.661-3.228-25.16 9.486c-9.499 12.715-21.493 29.164-21.493 29.164l33.497 3.306 13.156-41.958"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M439.205 355.126l7.114-34.558 15.823-137.309-23.67 1.804c-19.188 40.099-40.774 113.158-56.321 170.063h57.054z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M501.119 355.126c-.139-52.161-.176-107.243.237-122.248.837-30.334-25.859-47.405-25.859-47.405l-13.358-2.216-12.569 48.128s-1.812 65.607-4.938 123.739h56.487v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M446.462 322.671h-.016a.451.451 0 01-.433-.466 3877.207 3877.207 0 001.568-53.691c0-.035.006-.07.014-.105l8.37-32.048a.45.45 0 01.87.229l-8.358 31.997c-.028 1.34-.581 26.914-1.568 53.652a.449.449 0 01-.449.434l.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M299.583 210.445l1.773-1.168a46.905 46.905 0 0122.238-7.602l26.985-8.565-4.059-20.485-38.277-.231c-4.041.264-7.692 1.775-11.88 3.183l-4.802 1.614-10.573 17.439 18.593 15.817.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M299.583 210.895a.462.462 0 01-.292-.106l-18.593-15.818a.45.45 0 01-.094-.576l10.573-17.44a.45.45 0 01.241-.192l4.802-1.614c.727-.245 1.44-.493 2.14-.736 3.32-1.156 6.456-2.246 9.854-2.469l38.308.229a.45.45 0 01.439.362l4.059 20.485a.453.453 0 01-.304.518l-26.986 8.564a.558.558 0 01-.102.02 46.572 46.572 0 00-22.026 7.532l-1.772 1.168a.45.45 0 01-.247.073zm-18.011-16.361l18.044 15.351 1.492-.984a47.483 47.483 0 0122.4-7.673l26.552-8.427-3.91-19.728-37.909-.229c-3.245.213-6.324 1.284-9.585 2.42-.702.245-1.417.493-2.148.738l-4.647 1.561-10.289 16.971z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M430.347 112.663c-4.616.368-8.796 2.894-11.92 6.32-10.363 11.367-31.776 41.86-31.776 41.86s-64.007 11.013-70.908 11.555l7.853 29.769c6.27-.562 83.472-12.244 83.472-12.244l-29.013 140.238c22.867 17.924 41.822 15.441 41.822 15.441l20.49-233.095s-7.522-.043-10.022.158l.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M442.535 112.503l-10.505.078s-9.483-1.311-18.808 12.526l-19.508 25.847 16.462 14.115-3.108 24.854-8.258 39.915 31.217.317 12.51-117.652h-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M406.943 191.016a.45.45 0 01-.441-.542l3.719-17.99a.452.452 0 01.53-.35.451.451 0 01.35.532l-3.719 17.99a.448.448 0 01-.439.358v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M475.091 122.184l-5.801-10.245s-15.696-.278-30.336.734c-1.697.117-3.237 1.424-3.892 2.997l-7.843 19.679a45.279 45.279 0 00-3.169 22.76l8.717 41.103 31.555.127 10.769-77.155z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M464.322 345.6V111.252s18.024-1.023 28.427 16.801c9.509 16.288 9.926 50.267 9.926 50.267l-8.429 5.068 26.13 146.468s-24.233 12.985-56.054 15.746v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M485.082 119.292a.444.444 0 01-.288-.106c-9.511-7.994-20.339-7.491-20.447-7.485a.45.45 0 01-.051-.9c.112-.008 11.281-.538 21.074 7.695a.451.451 0 01-.29.796h.002zM500.955 338.296a.45.45 0 01-.143-.878c10.526-3.522 17.583-7.046 19.063-7.809l-15.671-87.848c-1.779-9.973-7.028-36.587-7.081-36.855a.45.45 0 01.882-.176c.053.268 5.302 26.89 7.083 36.872l15.731 88.173a.452.452 0 01-.231.476c-.074.041-7.584 4.036-19.49 8.018a.42.42 0 01-.143.023v.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M544.094 230.155H336.135c-8.747 0-15.837 7.103-15.837 15.865v111.982c0 8.761 7.09 15.864 15.837 15.864h207.959c8.747 0 15.837-7.103 15.837-15.864V246.02c0-8.762-7.09-15.865-15.837-15.865z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M544.094 374.316H336.135c-8.981 0-16.286-7.319-16.286-16.314V246.018c0-8.996 7.305-16.315 16.286-16.315h207.959c8.98 0 16.286 7.319 16.286 16.315v111.984c0 8.995-7.306 16.314-16.286 16.314zM336.135 230.605c-8.484 0-15.386 6.914-15.386 15.415v111.984c0 8.498 6.902 15.412 15.386 15.412h207.959c8.484 0 15.386-6.914 15.386-15.412V246.02c0-8.499-6.902-15.415-15.386-15.415H336.135z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M381.554 303.299c6.721-6.732 6.721-17.647 0-24.379-6.72-6.733-17.617-6.733-24.337 0-6.721 6.732-6.721 17.647 0 24.379 6.72 6.732 17.617 6.732 24.337 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M369.387 308.798c-9.736 0-17.658-7.934-17.658-17.689 0-9.754 7.92-17.689 17.658-17.689 9.737 0 17.658 7.935 17.658 17.689 0 9.755-7.921 17.689-17.658 17.689zm0-34.476c-9.242 0-16.758 7.532-16.758 16.787 0 9.256 7.518 16.787 16.758 16.787 9.239 0 16.757-7.531 16.757-16.787 0-9.255-7.518-16.787-16.757-16.787z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M400.701 339.718c9.504 0 17.209-7.718 17.209-17.239s-7.705-17.239-17.209-17.239-17.209 7.718-17.209 17.239 7.705 17.239 17.209 17.239z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M400.701 340.168c-9.736 0-17.658-7.935-17.658-17.689 0-9.755 7.92-17.689 17.658-17.689 9.738 0 17.658 7.934 17.658 17.689 0 9.754-7.92 17.689-17.658 17.689zm0-34.476c-9.241 0-16.758 7.531-16.758 16.787 0 9.255 7.519 16.787 16.758 16.787 9.24 0 16.758-7.532 16.758-16.787 0-9.256-7.518-16.787-16.758-16.787zM352.18 340.167a.449.449 0 01-.318-.769l65.73-65.845a.449.449 0 11.635.636l-65.73 65.845a.448.448 0 01-.319.133h.002zM530.567 336.86H505.78a.45.45 0 010-.9h24.787a.45.45 0 010 .9zM488.239 336.86H433.58a.45.45 0 010-.9h54.659a.45.45 0 010 .9zM530.567 325.043h-15.41a.45.45 0 010-.9h15.41a.45.45 0 010 .9zM504.165 325.043h-70.583a.45.45 0 110-.9h70.583a.45.45 0 110 .9zM530.567 313.227h-42.328a.45.45 0 010-.9h42.328a.45.45 0 010 .9zM476.473 313.227H433.58a.45.45 0 010-.9h42.893a.45.45 0 010 .9z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E2EAFF",
                        d: "M522.538 273.872h-80.93c-4.433 0-8.028-3.6-8.028-8.042 0-4.443 3.593-8.043 8.028-8.043h80.93c4.433 0 8.029 3.6 8.029 8.043 0 4.442-3.594 8.042-8.029 8.042z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M491.71 235.05l-44.235 9.683a4.872 4.872 0 01-5.479-2.769l-28.325-62.593c-1.313-2.9.366-6.283 3.455-6.96l43.096-9.434a4.942 4.942 0 015.554 2.808l28.764 63.563c1.076 2.376-.3 5.148-2.83 5.702z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M470.638 149.559s13.535-30.792 14.117-30.991c.631-.217 28.924 27.346 33.73 56.344 4.807 28.998-14.091 39.471-44.133 50.498-30.04 11.025-37.434 12.293-36.415 7.58 0 0-3.567-.413-4.223-3.61 0 0-3.495-1.434-3.932-4.631 0 0-7.698-3.346-.572-11.045l1.744 3.851s9.315-1.517 12.811-4.714c3.495-3.197 1.202-5.513-.656-6.394-1.856-.882-7.32-4.852-6.336-7.057.982-2.205 9.722 1.213 12.891 1.102 3.169-.11 30.695-13.565 37.797-18.758 0 0-9.285-22.134-16.823-32.173v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M473.884 224.095h-.01a.449.449 0 01-.439-.46c.215-9.9-3.373-19.849-9.84-27.295a.451.451 0 01.68-.591c6.612 7.613 10.279 17.783 10.061 27.904a.452.452 0 01-.45.44l-.002.002zM488.423 181.885a.45.45 0 01-.26-.818 44.734 44.734 0 005.691-4.776.451.451 0 01.633.642 45.764 45.764 0 01-5.805 4.872.456.456 0 01-.259.082v-.002zM439.084 233.473c-.441 0-.882-.014-1.321-.045a.449.449 0 01-.418-.478.446.446 0 01.478-.42 19.57 19.57 0 0011.34-2.761.45.45 0 11.464.771 20.526 20.526 0 01-10.545 2.933h.002zM435.176 229.837a20.64 20.64 0 01-1.631-.064.449.449 0 01-.413-.485.456.456 0 01.484-.413 20.81 20.81 0 0012.078-2.8.45.45 0 11.457.777 21.748 21.748 0 01-10.973 2.987l-.002-.002zM434.449 225.987c-1.562 0-3.124-.207-4.637-.628a.45.45 0 01.241-.868c4.674 1.303 9.858.44 13.871-2.307a.45.45 0 11.506.743c-2.93 2.006-6.454 3.06-9.983 3.06h.002zM436.005 90.869s-19.706-5.367-13.921-21.471c4.245-11.823 24.845-18.894 37.27-2.577 0 0 19.063-.645 8.568 21.686 0 0-4.88 9.807-14.493 10.472-4.791.332-17.422-8.112-17.422-8.112l-.002.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M460.314 68.775c5.1-4.562 4.505-13.564-1.327-20.105-5.832-6.542-14.694-8.146-19.794-3.584-5.099 4.563-4.505 13.565 1.327 20.106 5.833 6.541 14.695 8.146 19.794 3.583z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M468.875 63.07c5.722-3.747 6.477-12.737 1.686-20.08-4.791-7.342-13.313-10.257-19.036-6.51-5.722 3.747-6.477 12.736-1.686 20.079 4.791 7.342 13.314 10.257 19.036 6.51z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M475.58 70.53c4.414-5.23 2.574-14.06-4.111-19.724-6.686-5.663-15.685-6.015-20.1-.785-4.414 5.23-2.574 14.06 4.111 19.724 6.686 5.663 15.685 6.015 20.1.785z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M483.532 61.076c4.415-5.23 2.575-14.06-4.111-19.724-6.685-5.664-15.684-6.015-20.099-.785-4.415 5.23-2.574 14.06 4.111 19.724 6.686 5.663 15.684 6.015 20.099.785z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M450.46 91.31l12.243 19.942-23.853 26.273 2.268-23.344 4.292-2.414-7.516-12.19 12.566-8.266z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M443.458 113.316a.451.451 0 01-.22-.843l1.543-.867-7.269-11.792a.45.45 0 01.145-.618l12.723-7.97a.448.448 0 01.621.145l12.086 19.646a.45.45 0 01-.766.472l-11.849-19.258-11.959 7.49 7.279 11.811a.452.452 0 01-.161.63l-1.952 1.098a.45.45 0 01-.221.058v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M451.987 93.71s-6.33 10.294-18.81 8.738c-12.447-1.553-1.552-28.612-1.552-28.612s1.493 3.113 7.941 2.635c6.448-.48 10.628.838 7.882 7.422-2.746 6.585 3.357 3.707 3.357 3.707s5.899-5.682 8.229-1.792c2.329 3.89-1.732 8.977-7.047 7.901z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M435.691 103.057a20.83 20.83 0 01-2.569-.161c-2.211-.276-3.873-1.336-4.939-3.154-4.382-7.462 2.722-25.317 3.026-26.074a.451.451 0 01.402-.282c.176-.02.343.094.421.256.012.024 1.486 2.825 7.502 2.379 4.6-.342 7.308.288 8.527 1.982.992 1.38.929 3.365-.198 6.062-.993 2.38-.676 3.181-.399 3.447.644.616 2.42.006 3.086-.293.498-.466 3.906-3.552 6.622-3.194.951.126 1.707.648 2.246 1.55 1.094 1.826.967 4.02-.335 5.866-1.505 2.134-4.182 3.2-6.888 2.762-1.027 1.489-6.617 8.852-16.506 8.852l.002.002zm-3.937-28.294c-1.313 3.512-6.464 18.274-2.795 24.523.931 1.585 2.33 2.473 4.276 2.716.845.104 1.664.153 2.45.153 10.436 0 15.863-8.588 15.92-8.683a.448.448 0 01.472-.204c2.454.499 4.919-.424 6.275-2.344 1.09-1.547 1.202-3.373.298-4.885-.398-.665-.919-1.03-1.595-1.12-2.442-.322-5.901 2.971-5.936 3.004a.392.392 0 01-.12.082c-.296.141-2.928 1.33-4.153.157-.801-.767-.737-2.22.19-4.444.982-2.353 1.082-4.1.298-5.19-1.005-1.395-3.533-1.922-7.731-1.611-4.749.353-6.95-1.189-7.847-2.158l-.002.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M451.887 91.19a.448.448 0 01-.308-.775 6.41 6.41 0 014.089-1.743.444.444 0 01.468.431.449.449 0 01-.431.469 5.494 5.494 0 00-3.508 1.495.454.454 0 01-.31.125v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M74.912 373.867l17.328-52.505c-.564 3.526-6.487 46.982-7.457 52.505h71.782c5.581-79.364-7.622-189.48-7.622-189.48l-80.775 7.034C57.208 210.924 23.06 311.824.45 373.869h74.463v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M.45 374.316a.45.45 0 01-.42-.603c6.386-17.528 13.559-37.775 21.155-59.21C40.22 260.772 59.907 205.209 67.778 191.2a.448.448 0 01.353-.227l80.775-7.034a.446.446 0 01.486.394c.11.923 11.002 93.062 8.66 168.637a.448.448 0 01-.464.436.45.45 0 01-.435-.465c2.259-72.84-7.791-161.103-8.602-168.068l-80.103 6.975c-7.91 14.277-27.484 69.523-46.414 122.956C14.438 336.242 7.265 356.49.876 374.022a.452.452 0 01-.423.296l-.004-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M75.025 374.091a.507.507 0 01-.143-.022.454.454 0 01-.284-.571L116.7 247.803a10.72 10.72 0 017.728-7.065l5.311-1.227a.45.45 0 01.202.877l-5.311 1.228a9.818 9.818 0 00-7.077 6.472L75.451 373.784a.451.451 0 01-.426.307z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M84.785 374.316c-.02 0-.043 0-.063-.004a.451.451 0 01-.382-.509l7-49.304a.453.453 0 01.508-.382.451.451 0 01.382.509l-7 49.304a.45.45 0 01-.445.386z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M137.68 64.364L120.5 93.937c7.697 3.47 18.293 9.286 21.729 13.923l14.459-26.576c-.333-1.882-11.196-26.131-19.008-16.918v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M142.229 108.31a.451.451 0 01-.361-.182c-3.335-4.502-13.695-10.237-21.552-13.78a.451.451 0 01-.204-.638l17.18-29.573a.74.74 0 01.045-.066c1.633-1.926 3.524-2.618 5.615-2.05 6.983 1.895 13.928 17.772 14.177 19.181.018.1 0 .204-.049.294l-14.459 26.577a.446.446 0 01-.363.233h-.031l.002.004zm-21.09-14.578c7.585 3.46 17.276 8.859 21.019 13.316L156.21 81.22c-.578-2.016-7.181-16.613-13.491-18.325-1.739-.472-3.269.094-4.67 1.733l-16.908 29.106-.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M139.705 35.298c2.737-2.32 5.26-3.273 8.125-3.189 2.865.084 5.766 2.555 5.395 5.402 5.497-6.108 14.53-8.763 22.448-6.603 5.109 1.395 10.018 5.227 10.72 10.483.596 4.465-2.013 8.876-5.556 11.653-3.543 2.778-7.91 4.234-12.184 5.642 3.257.617 4.727 4.475 4.39 7.778-.292 2.86-1.846 5.805-4.633 7.603-5.656 3.651-14.164 4.98-20.764 3.66-5.574-1.117-14.283-8.047-15.228-14.413-1.08-7.267-3.204-11.284-.394-18.319 1.684-4.217 4.629-7.11 7.684-9.7l-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M137.61 67.565a.45.45 0 01-.445-.393c-.096-.76-.537-1.495-1.211-2.015-.671-.52-1.494-.759-2.254-.66a.45.45 0 01-.116-.894c.994-.133 2.058.174 2.92.838.859.665 1.427 1.618 1.554 2.614a.45.45 0 01-.448.508v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M141.233 62.185c-.484-1.335-.884-2.7-1.854-3.819-1.419-1.636-3.617-2.52-5.777-2.123-2.556.469-4.674 2.612-5.296 5.14-.623 2.529.187 5.319 1.931 7.25 1.742 1.93 4.335 3.01 6.932 3.086.045.151.098.299.145.45.972-1.131 1.726-2.465 2.287-3.852.795-1.963 1.236-4.047 1.634-6.132h-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M137.312 72.621a.449.449 0 01-.428-.317l-.049-.15c-2.708-.159-5.221-1.323-6.933-3.22-1.898-2.106-2.678-5.04-2.033-7.659.676-2.737 2.999-4.989 5.654-5.474 2.25-.413 4.625.459 6.197 2.27.904 1.042 1.337 2.27 1.758 3.456l.18.503c.028.075.034.16.018.239-.388 2.03-.835 4.179-1.66 6.218-.623 1.538-1.417 2.878-2.363 3.977a.45.45 0 01-.341.157zm-2.672-16.02c-.319 0-.639.029-.956.086-2.317.425-4.349 2.401-4.941 4.805-.576 2.332.126 4.952 1.827 6.838 1.593 1.765 4.064 2.863 6.612 2.939a.427.427 0 01.224.07c.693-.915 1.289-1.984 1.777-3.19.778-1.922 1.213-3.978 1.586-5.927l-.141-.393c-.41-1.157-.796-2.254-1.588-3.166-1.142-1.317-2.765-2.062-4.4-2.062z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M163.706 53.188c-.76-2.08-15.112 2.108-13.432 6.518 1.973 5.181-3.285 5.93-3.138 6.239 2.438 5.144 1.55 13.254 6.963 15 3.095.997 11.677-2.68 14.715-3.785a55.96 55.96 0 00-.351-4.079c-.708-6.058-2.666-14.162-4.757-19.89v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M155.465 76.639c-5.413-1.743-5.893-5.55-8.331-10.696-.145-.307-.267-.622-.402-.933-.135.225-.31.428-.541.6-1.295.96-3.214-.035-4.053-1.414-.388-.636-.658-1.32-.909-2.008-.398 2.084-.839 4.168-1.634 6.132-.561 1.387-1.314 2.72-2.286 3.851a46.607 46.607 0 005.905 12.255c2.05 3.02 4.525 5.852 7.704 7.64 3.179 1.787 8.927 3.362 12.282 1.928 3.483-1.489 5.527-3.467 6.476-7.14.611-2.357-1.012-10.473-1.123-12.913-3.961-.082-9.995 3.694-13.09 2.698h.002zM136.984 66.97a.453.453 0 01-.419-.282 5.534 5.534 0 00-3.179-3.091.452.452 0 01.31-.847 6.444 6.444 0 013.704 3.602.45.45 0 01-.416.618z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M207.974 131.231c3.169-5.659 9.384-15.928 11.691-20.579 0 0 8.158 2.491 14.306 2.473 6.148-.018 11.781.718 12.286-1.499.504-2.218-3.798-4.061-6.965-4.314 0 0 16.36.38 15.986-4.764-.374-5.144-7.096-2.94-7.096-2.94s7.751-2.773 5.858-6.547c-1.892-3.772-7.595-.153-7.595-.153s4.386-2.987 2.405-5.552c-1.981-2.564-11 3.216-18.185.199 0 0 9.317-2.367 8.488-5.864-.829-3.496-7.398-1.487-13.619-.681-6.22.805-14.908.971-23.116 10.977-8.211 10.009-13.63 18.096-13.63 18.096s9.464 12.208 19.184 21.146l.002.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M207.974 131.681a.449.449 0 01-.305-.118c-9.635-8.863-19.138-21.081-19.234-21.202a.45.45 0 01-.019-.527c.056-.082 5.526-8.221 13.657-18.131 7.62-9.288 15.791-10.244 21.756-10.94.567-.065 1.117-.13 1.65-.2 1.241-.161 2.503-.37 3.724-.574 5.168-.862 9.63-1.606 10.389 1.6.723 3.051-4.704 5.154-7.422 6.003 3.512.936 7.355.067 10.516-.647 3.052-.69 5.464-1.235 6.521.137.505.653.697 1.383.57 2.172-.12.751-.521 1.463-.996 2.073 1.096-.364 2.378-.598 3.51-.283.955.266 1.678.878 2.15 1.817.418.834.457 1.687.118 2.536-.545 1.366-2.009 2.491-3.381 3.291h.006c1.004 0 2.078.18 2.936.757.964.648 1.505 1.681 1.605 3.072.057.796-.216 1.52-.815 2.15-2.097 2.207-8.006 2.855-11.93 3.037 1.376.522 2.607 1.258 3.265 2.158.436.598.592 1.242.451 1.868-.48 2.103-4.019 2.021-8.915 1.904-1.231-.028-2.499-.065-3.808-.055h-.074c-5.47 0-12.337-1.898-14.001-2.383-1.529 3.021-4.423 7.983-7.224 12.788-1.627 2.79-3.163 5.425-4.308 7.472a.451.451 0 01-.392.231v-.006zm-18.626-21.616c1.4 1.779 9.854 12.393 18.513 20.448 1.115-1.974 2.538-4.416 4.037-6.989 2.902-4.975 5.901-10.121 7.365-13.073a.452.452 0 01.533-.231c.08.025 8.102 2.453 14.103 2.453h.311c1.233 0 2.43.028 3.591.055 3.96.092 7.7.182 8.017-1.205.086-.372-.012-.744-.298-1.133-1.023-1.397-4.049-2.452-6.265-2.63a.45.45 0 01-.412-.473.438.438 0 01.459-.427c.121.002 12.049.241 14.957-2.817.423-.444.608-.922.57-1.462-.082-1.115-.476-1.897-1.207-2.387-1.866-1.256-5.264-.168-5.299-.156a.451.451 0 01-.292-.853c.047-.016 4.735-1.722 5.695-4.124.243-.607.214-1.196-.088-1.795-.357-.714-.876-1.156-1.586-1.354-2.189-.61-5.338 1.358-5.368 1.378a.45.45 0 01-.495-.753c.025-.016 2.42-1.67 2.698-3.428.085-.54-.043-1.022-.394-1.477-.709-.918-2.981-.403-5.611.193-3.69.834-8.28 1.871-12.393.145a.45.45 0 01.064-.85c2.472-.629 8.757-2.811 8.161-5.323-.566-2.385-4.643-1.704-9.366-.919-1.229.205-2.499.418-3.757.58-.535.069-1.09.134-1.66.2-6.138.718-13.777 1.61-21.166 10.618-7.273 8.865-12.407 16.304-13.42 17.791l.003-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M238.865 107.476h-.03l-4.856-.326a.449.449 0 01.059-.898l4.856.326a.45.45 0 01-.029.9v-.002zM242.024 100.322c-2.461 0-4.921-.192-7.359-.576a.45.45 0 01.141-.89c4.137.652 8.345.74 12.504.264a.45.45 0 01.498.396.45.45 0 01-.396.499 46.9 46.9 0 01-5.388.309v-.002zM240.593 94.186c-2.218 0-4.435-.256-6.579-.767a.45.45 0 11.208-.875c3.696.88 7.622.98 11.357.288a.45.45 0 01.525.362.452.452 0 01-.362.526c-1.69.313-3.42.468-5.149.468v-.002zM218.702 110.775a.488.488 0 01-.076-.007 11.696 11.696 0 00-3.853-.008.451.451 0 01-.145-.89 12.48 12.48 0 014.149.009.448.448 0 01.368.519.448.448 0 01-.443.375v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M90.406 149.665l65.639 2.455 35.22-47.469 28.844 22.445-33.61 55.611a38.81 38.81 0 01-32.366 15.678l-74.657-2.305 10.93-46.417v.002zM299.649 121.101c16.732-16.762 16.732-43.939 0-60.7-16.733-16.763-43.862-16.763-60.595 0-16.733 16.761-16.733 43.938 0 60.7s43.862 16.762 60.595 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M269.351 124.948c-18.823 0-34.137-15.341-34.137-34.196 0-18.855 15.314-34.196 34.137-34.196 18.822 0 34.136 15.341 34.136 34.196 0 18.855-15.314 34.196-34.136 34.196zm0-67.492c-18.328 0-33.238 14.936-33.238 33.296s14.91 33.296 33.238 33.296c18.327 0 33.237-14.936 33.237-33.296s-14.91-33.296-33.237-33.296z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M267.145 117.408v-6.558c-3.759-.065-7.649-1.233-9.917-2.857l1.555-4.351c2.334 1.559 5.705 2.792 9.336 2.792 4.602 0 7.714-2.663 7.714-6.363 0-3.7-2.528-5.78-7.324-7.728-6.612-2.597-10.697-5.584-10.697-11.233 0-5.65 3.824-9.48 9.788-10.455v-6.56h4.019v6.3c3.889.13 6.548 1.17 8.429 2.273l-1.622 4.287c-1.362-.779-4.018-2.209-8.167-2.209-4.991 0-6.871 2.989-6.871 5.584 0 3.377 2.397 5.065 8.037 7.403 6.677 2.726 10.048 6.103 10.048 11.884 0 5.13-3.565 9.937-10.242 11.039v6.754h-4.084l-.002-.002zM206.461 87.831c6.936-5.922 13.87-6.147 19.075-6.822 6.219-.805 13.045-2.865 13.619.682.404 2.497-4.576 4.34-8.488 5.862-1.646.64-2.981.957-4.002 2.317-.884 1.178-.825 2.197-1.985 4.451a18.58 18.58 0 01-1.556 2.514l-16.666-9.006.003.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M223.125 97.287a.451.451 0 01-.362-.718c.568-.775 1.078-1.6 1.517-2.454.531-1.031.795-1.782 1.027-2.445.262-.746.488-1.389.999-2.07.943-1.257 2.115-1.691 3.471-2.192.235-.086.478-.176.727-.274l.398-.156c3.437-1.334 8.141-3.162 7.808-5.216-.075-.47-.283-.822-.639-1.076-1.429-1.029-4.953-.44-8.684.184-1.245.21-2.532.424-3.794.587-.535.07-1.09.136-1.66.201-4.927.575-11.061 1.293-17.18 6.517a.45.45 0 11-.584-.685c6.328-5.404 12.611-6.137 17.66-6.728.568-.065 1.117-.13 1.65-.2 1.246-.162 2.524-.375 3.761-.581 4.09-.683 7.625-1.275 9.356-.027.549.395.888.955 1.003 1.665.449 2.774-4.237 4.594-8.372 6.2l-.398.153c-.256.098-.501.19-.741.278-1.275.47-2.279.843-3.065 1.89-.427.569-.613 1.097-.868 1.827-.231.657-.517 1.473-1.074 2.559-.46.896-.997 1.761-1.593 2.575a.447.447 0 01-.363.184v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M160.551 217.543c7.927-17.22 14.342-70.202 14.342-70.202s-35.759-63.826-51.408-58.072C72.94 107.858 60.221 174.37 60.748 192.345c.519 17.736 91.874 42.417 99.803 25.196v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M234.522 168.873h33.252c9.964 0 19.81 2.187 28.839 6.409l-8.261 3.055 15.921 27.659c2.672 4.645-2.657 9.982-6.618 6.58a7.479 7.479 0 01-.27-.245c.978 4.79-5.537 6.023-8.837 1.841.896 4.387-5.05 6.578-9.031 1.881 1.452 5.04-5.634 7.026-8.874 1.849-3.42-5.463-13.94-23.473-13.94-23.473h-22.775l.596-25.558-.002.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M275.691 221.398c-1.901 0-4.003-.975-5.43-3.254-3.179-5.079-12.596-21.172-13.817-23.263h-22.516a.457.457 0 01-.323-.135.463.463 0 01-.128-.325l.596-25.558a.45.45 0 01.449-.44h33.252a69.015 69.015 0 0129.03 6.452.452.452 0 01-.035.832l-7.763 2.872 15.653 27.194c1.57 2.727.553 5.68-1.264 7.19-1.66 1.381-3.743 1.507-5.466.387-.029 1.499-.803 2.716-2.189 3.36-1.785.831-4.558.581-6.671-1.317-.114 1.409-.919 2.598-2.263 3.254-1.749.853-4.363.71-6.658-1.299-.006 1.594-.856 2.94-2.369 3.617a5.144 5.144 0 01-2.097.433h.009zm-41.304-27.417h22.314c.159 0 .308.084.388.223.106.18 10.554 18.066 13.934 23.461 1.715 2.739 4.514 3.318 6.395 2.475 1.556-.697 2.179-2.178 1.666-3.96a.452.452 0 01.776-.417c2.183 2.575 4.866 2.894 6.559 2.07 1.378-.671 2.009-2.006 1.69-3.571a.451.451 0 01.795-.37c1.876 2.378 4.731 2.804 6.464 1.996 1.327-.62 1.905-1.884 1.581-3.469a.454.454 0 01.222-.485.45.45 0 01.529.07c.084.079.167.155.249.227 1.783 1.53 3.688 1.02 4.878.032 1.478-1.229 2.44-3.645 1.058-6.046l-15.921-27.656a.457.457 0 01-.032-.379.449.449 0 01.267-.27l7.239-2.677a68.14 68.14 0 00-27.662-5.914h-32.813l-.576 24.658v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M255.246 194.481l9.727-4.206a3.312 3.312 0 014.354 1.731l.255.591a3.323 3.323 0 01-1.728 4.361l-9.728 4.207a3.31 3.31 0 01-4.353-1.731l-.255-.592a3.322 3.322 0 011.728-4.361z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M256.811 201.897c-.469 0-.939-.088-1.388-.268a3.747 3.747 0 01-2.067-2.009l-.255-.591a3.759 3.759 0 01-.043-2.884 3.747 3.747 0 012.006-2.07l9.727-4.205a3.724 3.724 0 012.879-.043 3.743 3.743 0 012.066 2.008l.256.591a3.778 3.778 0 01-1.963 4.955l-9.727 4.205a3.747 3.747 0 01-1.491.311zm9.471-11.436c-.386 0-.77.078-1.134.235l-9.727 4.205a2.85 2.85 0 00-1.527 1.575 2.86 2.86 0 00.032 2.195l.255.591a2.851 2.851 0 001.573 1.53c.71.283 1.488.27 2.191-.032l9.727-4.206a2.873 2.873 0 001.495-3.77l-.255-.591a2.857 2.857 0 00-1.573-1.53 2.882 2.882 0 00-1.057-.204v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M258.883 200.675l9.728-4.206a3.311 3.311 0 014.353 1.731l.255.591a3.322 3.322 0 01-1.728 4.361l-9.728 4.207a3.312 3.312 0 01-4.353-1.731l-.255-.592a3.322 3.322 0 011.728-4.361z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M260.448 208.091a3.72 3.72 0 01-1.388-.268 3.74 3.74 0 01-2.067-2.009l-.255-.591a3.759 3.759 0 01-.043-2.884 3.745 3.745 0 012.005-2.07l9.728-4.205a3.724 3.724 0 012.879-.043 3.743 3.743 0 012.066 2.008l.255.591a3.776 3.776 0 01-1.962 4.954l-9.727 4.206a3.767 3.767 0 01-1.491.311zm9.468-11.434c-.377 0-.761.075-1.131.235l-9.727 4.205a2.844 2.844 0 00-1.526 1.575 2.85 2.85 0 00.033 2.195l.255.591a2.85 2.85 0 001.572 1.53c.711.283 1.489.27 2.191-.032l9.728-4.206a2.874 2.874 0 001.495-3.77l-.256-.591a2.864 2.864 0 00-2.632-1.73l-.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M263.049 206.865l9.728-4.207a3.312 3.312 0 014.353 1.731l.255.592a3.321 3.321 0 01-1.728 4.361l-9.727 4.207a3.314 3.314 0 01-4.354-1.731l-.255-.592a3.323 3.323 0 011.728-4.361z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M264.616 214.285c-.47 0-.94-.088-1.389-.268a3.745 3.745 0 01-2.066-2.009l-.256-.591a3.754 3.754 0 01-.042-2.884 3.742 3.742 0 012.005-2.07l9.727-4.206a3.733 3.733 0 012.879-.043 3.75 3.75 0 012.067 2.009l.255.591a3.776 3.776 0 01-1.962 4.954l-9.728 4.206a3.763 3.763 0 01-1.49.311zm9.47-11.436c-.386 0-.77.077-1.133.235l-9.728 4.205a2.853 2.853 0 00-1.527 1.575 2.86 2.86 0 00.032 2.195l.256.591a2.846 2.846 0 001.572 1.53c.71.282 1.488.27 2.191-.033l9.727-4.205a2.874 2.874 0 001.495-3.77l-.255-.591a2.848 2.848 0 00-1.573-1.53 2.883 2.883 0 00-1.057-.205v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M276.659 208.92l-8.019 3.468a2.737 2.737 0 00-1.425 3.595l.211.488a2.727 2.727 0 003.588 1.427l8.02-3.468a2.737 2.737 0 001.424-3.595l-.21-.488a2.728 2.728 0 00-3.589-1.427z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M269.931 218.584c-.396 0-.794-.076-1.174-.227a3.161 3.161 0 01-1.746-1.698l-.21-.487a3.19 3.19 0 011.66-4.187l8.018-3.467a3.18 3.18 0 014.18 1.663l.21.487c.337.781.349 1.647.037 2.438a3.146 3.146 0 01-1.695 1.749l-8.018 3.467a3.149 3.149 0 01-1.26.262h-.002zm7.808-9.43c-.306 0-.613.064-.902.189l-8.019 3.467a2.286 2.286 0 00-1.19 3.002l.21.487c.241.561.686.992 1.254 1.219a2.257 2.257 0 001.745-.026l8.019-3.469c.559-.242.99-.688 1.217-1.256a2.258 2.258 0 00-.027-1.749l-.21-.487a2.272 2.272 0 00-1.254-1.219 2.274 2.274 0 00-.841-.162l-.002.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M295.131 175.832l-21.174 7.12s-.435 7.129 6.563 5.57c9.843-2.191 11.843 1.796 17.045 3.195 8.476 2.283 12.944-2.375 12.944-2.375l-15.378-13.512v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M302.137 192.803c-1.399 0-2.963-.186-4.69-.652-1.568-.424-2.863-1.078-4.113-1.71-3.042-1.54-5.915-2.997-12.719-1.481-2.215.495-3.969.204-5.21-.859-2.079-1.778-1.905-5.042-1.897-5.179a.447.447 0 01.308-.401l22.408-7.376a.45.45 0 11.279.855l-22.101 7.276c.012.789.182 2.939 1.591 4.142 1.017.867 2.505 1.09 4.429.66 7.113-1.585 10.268.013 13.319 1.557 1.266.64 2.46 1.246 3.941 1.644 8.096 2.179 12.459-2.207 12.502-2.252a.45.45 0 01.647.626c-.151.158-3.101 3.15-8.694 3.15z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M151.746 113.376l37.189 54.237h59.041v38.948l-65.381 3.784a38.82 38.82 0 01-31.87-16.671l-42.689-61.398 43.708-18.9h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M195.314 168.062h-6.381a.457.457 0 01-.372-.195l-21.225-30.955a.45.45 0 01.741-.51l21.093 30.762h6.144a.45.45 0 010 .9v-.002zM165.229 206.689a.463.463 0 01-.201-.047 39.413 39.413 0 01-14.672-12.71l-40.673-58.498a.45.45 0 11.739-.513l40.673 58.498a38.509 38.509 0 0014.336 12.417.45.45 0 01-.202.853z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M39.706 35.44c6.796-6.808 6.796-17.846 0-24.654-6.797-6.809-17.815-6.809-24.612 0-6.796 6.808-6.796 17.846 0 24.654 6.797 6.808 17.816 6.808 24.612 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M26.373 31.682a.675.675 0 01-.482-.203l-6.834-6.977a.675.675 0 01.964-.947l6.272 6.405 8.421-11.768a.673.673 0 01.942-.155.677.677 0 01.155.943L26.922 31.4a.68.68 0 01-.496.28l-.05.002h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M85.898 98.364H27.4c-.25 0-.45-.2-.45-.45V46.487a.45.45 0 11.9 0v50.977h58.048a.45.45 0 010 .9z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M532.473 55.243c15.229 0 27.574-12.366 27.574-27.621C560.047 12.367 547.702 0 532.473 0 517.245 0 504.9 12.367 504.9 27.622c0 15.255 12.345 27.621 27.573 27.621z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M520.531 38.058a.678.678 0 01-.427-1.2l22.753-18.594a.673.673 0 01.949.096.678.678 0 01-.096.951l-22.753 18.593a.666.666 0 01-.426.152v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M543.308 25.902l-1.339-.184.914-6.601-6.638-.43.088-1.35 8.084.526-1.109 8.039zM547.228 41.617h-29.421a.675.675 0 01-.674-.675V14.89c0-.373.302-.675.674-.675.371 0 .673.303.673.675v25.376h28.746a.675.675 0 010 1.35h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M532.349 131.213H504.9a.45.45 0 010-.9h26.998l-.045-67.88a.45.45 0 11.898 0l.045 68.33a.45.45 0 01-.449.452l.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M462.937 111.634s17.33-4.201 36.226 23.075l-25.559 18.405 14.269 28.444-11.772 6.613-9.233-19.972s-1.325-4.144-3.232-4.729c-1.907-.585-3.473-31.179-3.473-31.179l2.774-20.655v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M440.65 236.011c-1.249 0-2.082-.233-2.591-.677-.52-.454-.733-1.121-.637-1.986-1.025-.243-3.445-1.08-4.096-3.649-.788-.376-3.432-1.831-3.951-4.645-.735-.376-3.002-1.722-3.53-4.25-.468-2.232.553-4.723 3.036-7.405a.449.449 0 01.739.119l1.599 3.534c1.691-.307 9.256-1.81 12.243-4.543 1.244-1.137 1.797-2.217 1.65-3.209-.211-1.401-1.732-2.226-2.193-2.444-1.452-.69-7.788-4.881-6.555-7.648.77-1.729 4.421-.896 8.282-.013 2.001.457 3.892.884 5.003.849 2.944-.102 29.709-13.115 37.258-18.464-1.19-2.794-9.709-22.533-16.627-31.747a.449.449 0 11.719-.54c7.485 9.969 16.784 32.048 16.878 32.269a.45.45 0 01-.149.538c-6.816 4.984-34.551 18.724-38.046 18.844-1.23.049-3.176-.401-5.234-.871-2.867-.655-6.791-1.553-7.261-.497-.757 1.698 3.902 5.414 6.118 6.466.563.267 2.421 1.284 2.697 3.125.196 1.309-.455 2.657-1.932 4.009-3.552 3.25-12.657 4.764-13.041 4.827a.45.45 0 01-.482-.257l-1.458-3.224c-1.942 2.254-2.736 4.304-2.36 6.099.527 2.514 3.21 3.707 3.236 3.719a.454.454 0 01.268.352c.396 2.894 3.626 4.261 3.659 4.275a.45.45 0 01.269.325c.58 2.833 3.702 3.238 3.835 3.254a.442.442 0 01.312.187c.074.102.1.233.074.355-.217 1.005.051 1.377.271 1.569 2.265 1.974 15.847-2.436 35.547-9.666 27.844-10.22 48.752-20.389 43.846-50.001-4.668-28.16-31.649-54.921-33.391-55.98a.452.452 0 01-.043-.865c.221-.076.41.036.482.079 1.776 1.064 29.103 28.06 33.838 56.616 5.021 30.293-16.182 40.629-44.421 50.995-19.492 7.153-29.362 10.178-33.857 10.178l-.004-.002zm44.248-117.013h-.002.002zM398.036 230.374a.447.447 0 01-.163-.445l8.625-39.465c-7.439 1.125-76.953 11.622-82.862 12.152a.447.447 0 01-.474-.334l-7.853-29.769a.448.448 0 01.399-.565c6.619-.519 66.875-10.863 70.683-11.517 1.662-2.361 21.82-30.907 31.705-41.752 3.481-3.819 7.82-6.116 12.216-6.468 2.489-.198 9.752-.159 10.058-.157.25 0 .45.204.448.454a.45.45 0 01-.45.448h-.002c-.075 0-7.532-.039-9.982.155-4.168.332-8.296 2.526-11.625 6.177-10.223 11.216-31.526 41.511-31.741 41.815a.447.447 0 01-.292.185c-2.556.439-61.403 10.558-70.414 11.509l7.62 28.884c8.392-.906 82.311-12.089 83.07-12.205a.46.46 0 01.394.135.455.455 0 01.115.401l-8.699 39.822"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_175",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H560.38V374.316H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/mainBanner/index.tsx






function MainBanner() {
    const { domain , formattedTitle  } = (0,useDomainContext/* useDomainContext */.w)();
    const categories = domain?.categories ?? [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${(styles_module_default()).mainSection}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:pt-40 pt-10 pb-16 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " flex flex-col lg:flex-row gap-10 lg:items-center ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-[575px] mx-auto lg:mx-0 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "font-bold lg:text-4xl text-2xl lg:leading-[45px] ",
                                    dangerouslySetInnerHTML: {
                                        __html: formattedTitle ?? "We Help You Find the Best Warranty Companies"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 lg:text-2xl text-lg lg:leading-8 font-light text-[#444444]",
                                    children: "What kind of warranty are you looking for?"
                                }),
                                categories.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: ` ${(styles_module_default())["categories-wrapper"]}`,
                                    children: categories?.map((category, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: `/${category.slugAlias ?? category.slug}`,
                                            className: (styles_module_default())["category-box"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative",
                                                    children: category.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(s3Icon/* default */.Z, {
                                                        image: category.icon,
                                                        svgClassName: (styles_module_default())["category-icon"]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: category.label ? category.label : category.name
                                                })
                                            ]
                                        }, index);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[300px] h-[200px] md:w-[560px] md:min-w-[560px] md:h-[374px] relative mx-auto lg:mx-0 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:mt-56 mt-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold lg:text-3xl text-xl lg:leading-[45px]",
                            children: "Why Get Warranties"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-5 lg:text-lg text-base lg:leading-8 font-light ",
                            children: "Car and home warranties can provide peace of mind and financial security by covering unexpected expenses for mechanical failures and major home systems/appliances. They offer convenience, protection, and potential savings, reducing the financial burden and allowing consumers to enjoy their homes and vehicles worry-free."
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52072);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `bg-[#F02B17] text-white py-4 sm:px-8 px-4 sm:text-xl font-semibold  ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)}`,
        children: "Get My Free Quote Now"
    });
}


/***/ }),

/***/ 37983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhatIsCarWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsCarWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 441 437",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M393.298 258.083c-18.631.801-39.359-20.392-44.131-41.088-4.909-21.294 10.365-27.832 14.122-55.925 4.264-31.914-13.337-39.236-19.506-83.895C342.39 67.1 334.342 8.79 355.342.96c19.415-7.242 66.353 27.672 70.334 64.63 2.839 26.352-18.252 34.352-14.842 65.066 2.989 26.945 20.216 29.699 23.381 55.737 3.848 31.696-16.459 70.639-40.917 71.69z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#91B3FA",
                d: "M390.912 265.629c9.628-33.691 7.37-88.031 3.779-127.678-3.891-42.93-10.13-78.366-10.194-78.718l-1.569.197c.064.353 6.298 35.741 10.178 78.617 3.581 39.535 5.838 93.693-3.731 127.187l1.537.401v-.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M74.652 259.236c27.869-6.399 47.695-48.122 37.459-66.027-6.916-12.093-23.071-5.471-33.51-18.861-13.331-17.093 5.171-37.939.192-72.516-4.237-29.428-24.426-61.48-41.381-60.392C19.662 42.577.64 80.34 8.337 108.044c5.005 18.017 18.7 22.404 17.926 37.747-.897 17.804-19.805 21.113-24.155 37.47-7.823 29.379 35.677 84.439 72.544 75.97v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M58.48 267.033c.145.037.305.042.465.01.56-.112.923-.656.811-1.216-15.092-75.506-4.392-155.761-4.285-156.567a1.03 1.03 0 10-2.044-.283c-.112.806-10.855 81.408 4.306 157.25.08.4.385.699.753.795l-.005.011z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint0_linear_0_407)",
                d: "M24.747 122.779a.483.483 0 00.32-.027c.251-.107.368-.4.256-.651-6.841-15.856-13.07-38.617-3.9-57.04 5.459-10.973 13.902-15.237 13.987-15.28a.492.492 0 00.224-.661.492.492 0 00-.662-.224c-.357.176-8.827 4.456-14.436 15.727-5.155 10.354-8.662 28.803 3.875 57.873a.501.501 0 00.33.283h.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M381.487 128.484a5.12 5.12 0 00-5.289-5.033l-110.957 3.544a5.123 5.123 0 00-4.958 5.273l5.475 183.768a5.126 5.126 0 005.172 4.974l108.727-1.057a5.126 5.126 0 003.623-1.548 5.136 5.136 0 001.452-3.661l-3.245-186.255v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#BDD0FB",
                opacity: "0.63",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M369.912 137.167H271.1c-.96 0-1.734.667-1.723 1.574l.096 8.705c.01.912.8 1.942 1.766 1.942l99.094.102c.982 0 1.74-1.057 1.708-1.98l-.299-8.747c-.032-.918-.848-1.596-1.825-1.596h-.005zM370.552 156.065l-99.238-.166c-.966 0-1.74.918-1.729 1.842l.096 8.816c.011.923.806 1.799 1.772 1.799l99.526.272c.988 0 1.756-.876 1.724-1.809l-.304-8.897c-.032-.929-.859-1.857-1.841-1.862l-.006.005zM371.225 175.939l-99.692-.341c-.971 0-1.751.442-1.74 1.371l.096 8.891c.011.929.806 1.633 1.777 1.639l99.959.443c.987 0 1.766-.7 1.734-1.639l-.304-8.976c-.032-.934-.848-1.393-1.836-1.399l.006.011zM371.876 195.322l-100.13-.512c-.971 0-1.756.624-1.745 1.563l.096 8.972c.011.939.806 1.467 1.783 1.473l100.401.619c.993.005 1.783-.518 1.751-1.468l-.31-9.057c-.032-.944-.859-1.59-1.846-1.595v.005zM372.532 214.871l-100.567-.683a1.753 1.753 0 00-1.751 1.756l.097 9.051c.01.95.816 1.975 1.798 1.98l100.861.801c.998.01 1.771-1.014 1.739-1.975l-.309-9.136c-.032-.95-.87-1.788-1.863-1.794h-.005zM373.199 234.596l-101.015-.859c-.982-.01-1.767.998-1.756 1.954l.096 9.131c.011.955.816 1.809 1.804 1.82l101.309.976a1.745 1.745 0 001.755-1.798l-.314-9.217c-.032-.96-.881-1.99-1.879-2.001v-.006zM373.893 255.186l-101.48-1.046c-.987-.011-1.782.507-1.772 1.467l.102 9.212c.01.966.821 1.638 1.809 1.649l101.762 1.163c1.009.011 1.804-.651 1.767-1.622l-.315-9.302c-.032-.971-.865-1.511-1.868-1.521h-.005zM374.571 275.268l-101.933-1.232c-.993-.011-1.788.699-1.778 1.665l.102 9.291c.011.971.822 1.468 1.814 1.478l102.217 1.345c1.014.011 1.814-.464 1.782-1.446l-.32-9.382c-.032-.977-.875-1.713-1.884-1.724v.005zM375.253 295.532l-102.392-1.419c-.998-.016-1.793.891-1.782 1.867l.101 9.377c.011.982.833 1.991 1.831 2.007l102.691 1.542c1.019.016 1.809-.976 1.772-1.969l-.321-9.468c-.032-.987-.886-1.921-1.9-1.937z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M211.312 26.646c-.064-3.293-2.727-5.998-5.999-5.998H81.75c-3.314 0-6.564 2.85-6.564 6.185v298.158c0 1.606.917 3.143 2.044 4.274 1.126 1.132 2.801 1.767 4.392 1.762l129.194-.358a6.04 6.04 0 004.306-1.814 6.153 6.153 0 001.73-4.377l-5.54-297.837v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#BDD0FB",
                opacity: "0.81",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M120.314 55.78l-35.201-.047-.278-18.167h35.234l.245 18.215zM159.769 55.775l-35.165-.048-.24-18.161h35.197l.208 18.21zM199.187 55.764l-35.133-.047-.202-18.151h35.164l.171 18.198zM120.752 88.394l-35.138.021-.278-18.049 35.175-.016.241 18.044zM160.143 88.368l-35.106.02-.24-18.038 35.138-.016.208 18.034zM199.485 88.34l-35.068.022-.197-18.028 35.1-.016.165 18.023zM121.189 120.778l-35.074.037-.277-17.985 35.111-.032.24 17.98zM160.511 120.734l-35.041.038-.241-17.975 35.074-.032.208 17.969zM199.79 120.697l-35.01.038-.197-17.969 35.042-.032.165 17.963zM121.627 153.055l-35.014.048-.278-17.921 35.052-.048.24 17.921zM160.88 152.996l-34.983.048-.24-17.916 35.02-.042.203 17.91zM200.089 152.937l-34.945.054-.203-17.911 34.983-.043.165 17.9zM122.065 185.215l-34.956.064-.278-17.863 34.994-.053.24 17.852zM161.247 185.139l-34.924.07-.235-17.857 34.957-.059.202 17.846zM200.388 185.07l-34.887.064-.197-17.846 34.919-.059.165 17.841zM122.497 217.268l-34.898.08-.272-17.804 34.93-.069.24 17.793zM161.611 217.177l-34.861.08-.234-17.793 34.892-.069.203 17.782zM200.686 217.086l-34.823.08-.202-17.782 34.86-.069.165 17.771zM122.929 249.208l-34.834.091-.277-17.734 34.871-.091.24 17.734zM161.978 249.102l-34.801.096-.235-17.735 34.833-.085.203 17.724zM200.985 248.995l-34.764.096-.203-17.724 34.801-.085.166 17.713zM123.361 281.038l-34.774.112-.273-17.681 34.807-.102.24 17.671zM162.341 280.92l-34.742.106-.235-17.67 34.775-.101.202 17.665zM201.284 280.797l-34.711.107-.197-17.66 34.743-.101.165 17.654zM123.788 312.761l-34.716.122-.267-17.616 34.748-.113.235 17.607zM162.703 312.628l-34.684.123-.234-17.612 34.716-.112.202 17.601zM201.577 312.489l-34.647.122-.197-17.6 34.679-.112.165 17.59z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#91B3FA",
                d: "M280.925 79.331c-.037-1.766-1.665-3.191-3.666-3.191H156.065c-2.023 0-4.173 1.468-4.173 3.26v250.431c0 1.34.854 2.62 1.926 3.565 1.073.945 2.647 1.473 4.163 1.473l122.523-.299c1.526 0 3.015-.549 4.082-1.515 1.068-.966 1.665-2.274 1.639-3.624l-5.294-250.105-.006.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M211.323 93.885l-39.647-.117.016-4.392 39.604.106.027 4.403zM211.429 110.066l-39.807-.165.016-4.424 39.765.149.026 4.44zM211.542 126.376l-39.973-.203.016-4.461 39.925.186.032 4.478zM211.654 142.818l-40.138-.24.01-4.499 40.096.23.032 4.509zM211.766 159.406l-40.309-.283.016-4.542 40.261.272.032 4.553zM211.99 192.99l-40.645-.368.016-4.617 40.597.358.032 4.627zM212.337 244.437l-41.163-.502.016-4.734 41.115.491.032 4.745zM211.878 176.126l-40.475-.326.016-4.573 40.427.309.032 4.59zM212.102 209.993l-40.816-.411.016-4.654 40.768.401.032 4.664zM212.219 227.14l-40.987-.453.011-4.691 40.944.443.032 4.701zM212.454 261.877l-41.339-.544.016-4.771 41.291.528.032 4.787zM212.572 279.473l-41.515-.592.016-4.814 41.467.577.032 4.829zM212.689 297.218l-41.696-.641.016-4.856 41.648.624.032 4.873zM212.812 315.112l-41.878-.688.016-4.894 41.825.672.037 4.91zM263.304 94.045l-39.898-.122-.043-4.403 39.85.112.091 4.413zM263.624 110.274l-40.058-.16-.043-4.445 40.015.154.086 4.451zM263.949 126.637l-40.223-.202-.043-4.478 40.181.192.085 4.488zM264.28 143.139l-40.394-.246-.043-4.515 40.347.23.09 4.531zM264.611 159.774l-40.56-.283-.048-4.552 40.518.272.09 4.563zM265.283 193.47l-40.906-.368-.043-4.632 40.859.357.09 4.643zM266.314 245.093l-41.43-.502-.048-4.749 41.382.491.096 4.76zM264.948 176.553l-40.736-.326-.043-4.595 40.688.315.091 4.606zM265.625 210.532l-41.077-.411-.048-4.675 41.029.406.096 4.68zM265.966 227.738l-41.253-.459-.048-4.707 41.211.443.09 4.723zM266.66 262.593l-41.606-.544-.048-4.793 41.558.534.096 4.803zM267.013 280.247l-41.788-.592-.048-4.835 41.74.581.096 4.846zM267.37 298.056l-41.968-.646-.048-4.872 41.92.629.096 4.889zM267.728 316.015l-42.151-.694-.048-4.915 42.102.678.097 4.931z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M370.712 423.348H70.244c-38.596 0-69.88-31.289-69.88-69.88v-92.482h440.228v92.482c0 38.596-31.284 69.88-69.88 69.88z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint1_linear_0_407)",
                d: "M134.062 176.248c33.492 0 60.642-27.15 60.642-60.642 0-33.492-27.15-60.642-60.642-60.642-33.492 0-60.643 27.15-60.643 60.642 0 33.492 27.151 60.642 60.643 60.642z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M157.346 86.771l-6.078-8.662c-.924-1.307-2.429-2.15-4.035-2.15h-27.682c-1.601 0-3.106.843-4.035 2.15l-6.079 8.63a4.963 4.963 0 00-.256 5.316l14.004 24.698c.881 1.543 2.519 2.626 4.291 2.626h11.832c1.772 0 3.41-1.073 4.29-2.615l14.004-24.63a5.048 5.048 0 00-.256-5.358v-.005zM146.555 147.36l-.998.053s-9.804 9.089-9.302 9.419c.251.166.827.646 1.334 1.095.107.09.155.234.123.373a.384.384 0 01-.267.288c-.24.07-.486.102-.726.16-.96.246-1.953.294-2.919.294-.961-.069-1.921-.144-2.802-.454-.459-.101-.859-.331-1.286-.491-.39-.224-.8-.416-1.147-.693l-.523-.401c-.171-.133-.31-.309-.465-.453-.331-.283-.549-.657-.816-.988-.23-.357-.433-.736-.619-1.12-.123-.406-.363-.822-.406-1.191l-.139-.555-.037-.138-.021-.208-.048-.422-.096-.838v-.053l-.011-.027v-.011c-.021-.144.021.182.016.144v-.08l.011-.154.01-.31v-.619l.134-.598c.037-.4.208-.779.341-1.158.091-.389.363-.742.523-1.121.23-.357.465-.72.731-1.067.561-.688 1.169-1.371 1.916-1.975.71-.629 1.516-1.11 2.343-1.649.806-.528 1.777-.864 2.519-1.323l.144-.123c.763-.192 1.34-.864 1.457-1.649l.102-.688.821-4.606a5.45 5.45 0 002.546-4.611 5.392 5.392 0 00-1.131-3.314l.64-3.581h-9.035l.656 2.657a5.446 5.446 0 00-2.028 4.238c0 1.713.844 3.33 2.146 4.323l.032 2.198a1.11 1.11 0 01-.673 1.031 9.251 9.251 0 00-1.072.523c-1.094.624-2.13 1.494-3.112 2.342-.992.822-1.889 1.831-2.711 2.909-.389.56-.752 1.158-1.089 1.766-.277.657-.64 1.26-.816 1.97-.203.693-.406 1.382-.459 2.108l-.117 1.072.037 1.068.027.534.016.266.01.134.022.171v.01l.01.027.011.053.171.827.085.411.043.209.08.266.341 1.062c.214.737.577 1.292.876 1.927.352.598.747 1.179 1.184 1.724.475.517.918 1.056 1.479 1.473.272.213.528.453.811.646l.875.544c.582.363 1.217.608 1.836.87.64.192 1.265.443 1.921.533 1.292.299 2.599.31 3.88.241 1.276-.144 2.53-.379 3.709-.828.294-.112.593-.208.881-.33l.848-.406.422-.203.139-.069.042-.027.091-.059.176-.112.71-.459c.491-.363 1.083-.827 1.521-1.27.438-.459.87-.912 1.222-1.43.758-.993 1.297-2.103 1.719-3.224.437-1.12.72-2.273.912-3.426.192-1.163.278-2.241.235-3.437l-.016-.01z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint2_linear_0_407)",
                d: "M91.089 293.957l-15.477-4.189s-3.66 1.062-3.122 6.505c.54 5.444 15.973 4.451 15.973 4.451l2.626-6.761v-.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint3_linear_0_407)",
                d: "M228.651 234.067c29.523 7.381 46.847 27.117 55.386 29.113 8.538 1.995 42.753 3.821 48.335 9.003 5.577 5.182.251 8.864 7.424 15.53 7.936 22.393-16.635 29.096-16.635 29.096l-223.362-1.814s-15.071 1.355-15.408-9.409c-.336-10.764 3.33-16.203 4.12-25.894.79-9.692.812-10.183 2.968-15.21 2.156-5.028 23.129-5.572 27.207-11.165 4.082-5.593 8.939-14.511 26.252-17.547 23.914-4.2 66.587-5.983 83.713-1.698v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint4_linear_0_407)",
                d: "M83.19 304.946c.385 12.37 21.364 10.182 21.455 10.172 0 0 16.678-12.766-6.266-12.28-6.895-.177-13.886-3.832-13.886-3.832l-1.302 5.934v.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint5_linear_0_407)",
                d: "M341.157 293.247s.219 3.154-5.695 6.378c-7.327 3.997-32.773-.395-32.773-.395l-2.903 16.373 23.983 1.222c-.56.155 31.493-1.692 17.388-23.578z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint6_linear_0_407)",
                d: "M122.47 269.52s-.72-5.619 5.182-12.509c5.903-6.89 9.35-11.432 13.887-12.6 4.536-1.169 37.758-5.764 39.94-2.231 2.183 3.533 4.99 25.243 4.99 25.243l-64.004 2.097h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M142.141 243.818c3.72-.555 31.978-3.837 39.274-2.904l1.889 7.264-60.866 21.342s-.289-4.622 2.748-9.185c5.107-7.658 13.059-16.026 16.95-16.517h.005z",
                opacity: "0.23"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint7_linear_0_407)",
                d: "M191.416 242.174c.918 4.195 4.313 24.645 4.313 24.645l71.833-.33s-22.644-20.809-40.053-24.102c-17.408-3.292-36.68-2.428-36.093-.213z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint8_linear_0_407)",
                d: "M225.054 240.845c-14.18-1.969-19.378-1.595-34.241-.293l1.43 5.945s22.121-4.339 42.732-1.831c0 0-5.294-3.18-9.921-3.821z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint9_linear_0_407)",
                d: "M330.718 271.116s-11.64-3.731-14.479 5.47c-2.706 8.774 23.557 11.132 23.557 11.132s-1.937-13.011-9.078-16.602z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M118.494 259.577a.87.87 0 00.197-.027c2.732-.827 5.033-3.703 7.701-7.039 3.891-4.867 8.304-10.385 15.498-11.757 13.801-2.636 34.716-4.456 34.924-4.477a.673.673 0 00.614-.732.662.662 0 00-.731-.613c-.208.016-21.198 1.852-35.063 4.493-7.685 1.468-12.462 7.44-16.304 12.243-2.524 3.159-4.707 5.881-7.034 6.591a.677.677 0 00.192 1.323l.006-.005zM97.104 267.241a.68.68 0 00.608-.374c1.131-2.284 6.153-3.319 11.005-4.323 1.734-.357 3.533-.731 5.182-1.163a.68.68 0 00.485-.827.686.686 0 00-.827-.486c-1.617.422-3.394.79-5.113 1.147-5.411 1.116-10.519 2.173-11.943 5.049a.675.675 0 00.603.977z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint10_linear_0_407)",
                d: "M155.496 315.955c.957-11.842-7.868-22.218-19.71-23.175-11.843-.957-22.219 7.867-23.176 19.71-.957 11.842 7.868 22.218 19.71 23.175 11.843.957 22.219-7.867 23.176-19.71z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint11_linear_0_407)",
                d: "M147.547 314.36c-.197 7.578-6.5 13.561-14.079 13.369-7.578-.198-13.56-6.501-13.368-14.079.197-7.578 6.5-13.561 14.078-13.369 7.579.198 13.561 6.501 13.369 14.079z",
                opacity: "0.57"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint12_linear_0_407)",
                d: "M308.415 318.237c2.938-11.512-4.012-23.227-15.524-26.165-11.512-2.939-23.226 4.011-26.165 15.523-2.938 11.512 4.012 23.227 15.524 26.165 11.512 2.939 23.226-4.011 26.165-15.523z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint13_linear_0_407)",
                d: "M301.062 313.031c-.198 7.578-6.501 13.56-14.079 13.368-7.578-.197-13.561-6.5-13.369-14.078.198-7.579 6.501-13.561 14.079-13.369 7.578.197 13.561 6.5 13.369 14.079z",
                opacity: "0.57"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M195.803 313.282h.069c.395 0 .705-.155.699-.545 0-.283-.176-.443-.416-.549-1.398-2.253-3.213-26.53-4.04-41.526a.696.696 0 00-.747-.651.723.723 0 00-.673.757c.006.107.593 10.514 1.431 20.948 1.707 21.24 2.759 21.566 3.677 21.566z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint14_linear_0_407)",
                d: "M258.58 272.188h-14.623a4.697 4.697 0 00-4.697 4.697v.747a4.696 4.696 0 004.697 4.696h14.623a4.696 4.696 0 004.696-4.696v-.747a4.697 4.697 0 00-4.696-4.697z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint15_linear_0_407)",
                d: "M365.279 235.279h5.305a1.7 1.7 0 011.703 1.649l3.047 103.155-13.924-.384 3.869-104.415v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint16_linear_0_407)",
                d: "M328.156 338.54l20.456-101.154a2.63 2.63 0 012.578-2.103h14.089l3.469 103.439-40.597-.177.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint17_linear_0_407)",
                d: "M368.754 354.792H92.669a2.312 2.312 0 01-2.31-2.311v-11.746a2.407 2.407 0 012.406-2.407h275.989v16.469-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint18_linear_0_407)",
                d: "M434.53 291.48l-12.99-47.321c-.326-1.201-1.265-1.409-2.322-1.409h-47.919c-2.588 0-4.686 2.182-4.686 4.872v106.993h70.985l-3.074-63.135h.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint19_linear_0_407)",
                d: "M439.189 332.345c-.395-.689-1.041-1.062-1.591-1.036l-27.554 1.398a3.661 3.661 0 00-3.474 3.629l-.15 19.715 31.194 2.001c1.132 0 2.412-1.441 2.412-3.458V334.97c0-.987-.437-1.932-.832-2.62l-.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint20_linear_0_407)",
                d: "M424.389 293.61l-7.85-37.95c-.272-1.324-1.249-2.327-2.364-2.327h-30.703c-.662 0-1.292.4-1.751.982-.458.576-.709 1.398-.688 2.204l.736 30.431c.033 1.43.897 2.636 2.05 2.86l37.817 7.466c.811.16 1.633-.187 2.188-.928.555-.742.768-1.767.565-2.743v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint21_linear_0_407)",
                d: "M424.385 252.581l-.459.053c-.78.091-1.484.529-1.948 1.206a3.157 3.157 0 00-.475 2.359l7.594 39.402c.246 1.286 2.999 2.103 4.712 2.209a.842.842 0 00.886-.779l.283-3.378c.027-.336 0-.672-.085-.993l-10.503-40.085-.005.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint22_linear_0_407)",
                d: "M395.309 296.977h-9.734a2.215 2.215 0 00-2.215 2.215v.4c0 1.223.991 2.215 2.215 2.215h9.734a2.215 2.215 0 002.215-2.215v-.4a2.215 2.215 0 00-2.215-2.215z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M370.482 323.918a.535.535 0 01-.533-.534v-56.981c0-.293.24-.534.533-.534.294 0 .534.241.534.534v56.981c0 .294-.24.534-.534.534z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint23_linear_0_407)",
                d: "M434.807 337.047h-6.704a2.444 2.444 0 00-2.444 2.444v7.343a2.445 2.445 0 002.444 2.445h6.704a2.445 2.445 0 002.444-2.445v-7.343a2.444 2.444 0 00-2.444-2.444z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M430.164 335.883v14.164h-1.74c-1.345 0-3.736-1.435-3.736-2.78v-8.032c0-1.345 2.386-3.352 3.736-3.352h1.74z",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint24_linear_0_407)",
                d: "M366.768 339.822H81.056l-.347-3.176 17.153-3.17 268.906.352v5.994z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint25_linear_0_407)",
                d: "M397.914 380.638c12.945 0 23.439-10.494 23.439-23.439 0-12.946-10.494-23.44-23.439-23.44s-23.439 10.494-23.439 23.44c0 12.945 10.494 23.439 23.439 23.439z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint26_linear_0_407)",
                d: "M402.274 375.74c10.229-2.414 16.565-12.664 14.15-22.893-2.414-10.23-12.664-16.565-22.894-14.151-10.229 2.415-16.564 12.664-14.15 22.894 2.414 10.229 12.664 16.565 22.894 14.15z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M413.898 364.297a.57.57 0 01-.208-.043.528.528 0 01-.283-.699 16.256 16.256 0 001.281-6.351c0-8.997-7.322-16.32-16.32-16.32-2.791 0-5.545.716-7.963 2.071a.533.533 0 11-.523-.929 17.38 17.38 0 018.486-2.209c9.585 0 17.387 7.797 17.387 17.387 0 2.349-.459 4.622-1.366 6.767a.534.534 0 01-.491.326z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint27_linear_0_407)",
                d: "M406.394 359.187a8.73 8.73 0 10-16.995-4.011 8.73 8.73 0 006.492 10.503 8.73 8.73 0 0010.503-6.492z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint28_linear_0_407)",
                d: "M197.763 363.217c2.974-12.599-4.829-25.223-17.428-28.197s-25.223 4.829-28.197 17.428c-2.973 12.599 4.829 25.223 17.428 28.197s25.224-4.829 28.197-17.428z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint29_linear_0_407)",
                d: "M179.314 376.387c10.229-2.414 16.565-12.664 14.15-22.894-2.414-10.229-12.664-16.565-22.893-14.15-10.23 2.414-16.565 12.664-14.151 22.894 2.414 10.229 12.664 16.565 22.894 14.15z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M190.94 364.947a.578.578 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.998-7.322-16.32-16.32-16.32-2.791 0-5.545.715-7.962 2.071a.532.532 0 11-.523-.929 17.377 17.377 0 018.485-2.209c9.585 0 17.387 7.797 17.387 17.387 0 2.348-.458 4.622-1.366 6.767a.533.533 0 01-.491.326z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint30_linear_0_407)",
                d: "M183.528 359.499a8.732 8.732 0 10-17.149-3.3 8.732 8.732 0 0017.149 3.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint31_linear_0_407)",
                d: "M330.335 360.129c1.274-12.883-8.136-24.359-21.018-25.633-12.883-1.275-24.359 8.135-25.633 21.017-1.275 12.883 8.135 24.359 21.017 25.633 12.883 1.275 24.359-8.135 25.634-21.017z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint32_linear_0_407)",
                d: "M310.62 376.545c10.321-1.987 17.077-11.965 15.09-22.286-1.988-10.321-11.966-17.077-22.287-15.09-10.321 1.988-17.076 11.966-15.089 22.287 1.988 10.321 11.966 17.077 22.286 15.089z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M323.016 364.947a.578.578 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.997-7.322-16.32-16.32-16.32-2.791 0-5.545.716-7.962 2.071a.532.532 0 11-.523-.929 17.377 17.377 0 018.485-2.209c9.585 0 17.388 7.797 17.388 17.387a17.25 17.25 0 01-1.367 6.767.532.532 0 01-.491.326z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint33_linear_0_407)",
                d: "M315.602 359.502a8.73 8.73 0 00-6.923-10.224 8.731 8.731 0 106.923 10.224z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint34_linear_0_407)",
                d: "M144.151 363.224c2.974-12.599-4.829-25.223-17.428-28.197-12.599-2.973-25.224 4.83-28.197 17.429-2.974 12.599 4.829 25.223 17.428 28.196 12.599 2.974 25.223-4.829 28.197-17.428z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint35_linear_0_407)",
                d: "M124.935 376.548c10.321-1.988 17.077-11.966 15.09-22.287-1.988-10.321-11.966-17.076-22.287-15.089-10.321 1.988-17.077 11.966-15.089 22.286 1.987 10.321 11.965 17.077 22.286 15.09z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M137.328 364.948a.573.573 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.998-7.322-16.32-16.32-16.32-2.791 0-5.545.715-7.968 2.071a.534.534 0 01-.523-.929 17.38 17.38 0 018.485-2.209c9.585 0 17.388 7.797 17.388 17.387a17.27 17.27 0 01-1.366 6.767.534.534 0 01-.491.326h.005z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint36_linear_0_407)",
                d: "M129.916 359.504a8.731 8.731 0 10-17.148-3.302 8.731 8.731 0 0017.148 3.302z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint37_linear_0_407)",
                d: "M6.314 256.781c3.148-5.241 3.96-9.942 3.03-16.026-1.536-10.039-.34-21.214 6.058-29.47 6.068-7.835 16.987-8.534 23.653-15.525.048-.048.197-.278.422-.63a17.38 17.38 0 002.71-8.811c.652-19.671 14.96-19.442 21.748-15.711 10.749 5.907 8.39 16.933 8.39 16.933-3 3.208-13.71-3.629-13.71-3.629l-4.452 7.146a96.68 96.68 0 014.094 1.895c10.087 4.947 11.17 43.591 5.486 49.771s-6.682 12.083-.95 22.196c5.732 10.113 2.418 23.322-28.077 34.278-4.936 1.777-12.376 1.964-17.254-.01C6.762 294.849.875 282.12.587 271.159c-.15-5.567 2.994-9.836 5.721-14.378h.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M14.217 244.148a.133.133 0 01-.133-.122c-1.254-13.977 3.02-23.183 6.831-28.44 4.787-6.613 10.38-9.484 12.931-10.14 5.625-1.441 8.246-8.059 8.272-8.128a.131.131 0 01.171-.075.13.13 0 01.075.171c-.027.069-2.7 6.815-8.454 8.288-3.26.838-8.656 4.333-12.781 10.039-3.779 5.224-8.027 14.366-6.778 28.263a.132.132 0 01-.123.144h-.01zM19.197 293.226s-.032 0-.048-.01c-.123-.048-12.227-4.899-12.013-18.321 0-.075.058-.134.133-.134.075 0 .133.064.133.134-.208 13.235 11.725 18.022 11.848 18.07a.13.13 0 01.075.171.132.132 0 01-.123.085l-.005.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint38_linear_0_407)",
                d: "M93.17 243.951s-13.202 15.813-26.496 2.973l-5.14 11.912s19.416 15.033 34.145-8.619l-2.508-6.266z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint39_linear_0_407)",
                d: "M60.562 214.599c-3.666-1.099-14.334-3.127-24.485 6.239a6.283 6.283 0 00-1.81 6.265c2.728 10.039 9.922 39.69 3.614 52.525 0 0 11.117 12.254 23.242 2.375 0 0 5.438-23.711 12.568-34.124 4.92-7.188-7.845-26.988-11.074-31.77a3.787 3.787 0 00-2.05-1.51h-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint40_linear_0_407)",
                d: "M54.884 195.461s-7.397 14.484-8.694 21.134c0 0 5.577 3.49 11.784-.32 0 0 2.61-15.104 3.816-17.708l-6.906-3.106z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint41_linear_0_407)",
                d: "M75.271 331.79c-.043 1.078 1.847 9.617 2.876 14.17a7.479 7.479 0 01-.805 5.379l-35.624 59.954a8.03 8.03 0 00-.934 2.332c-.65 2.813-2.006 9.708-1.302 15.984l1.841 3.827-7.967-1.81-1.735-21.4 2.258-1.377a10.719 10.719 0 004.333-5.076c3.223-7.823 11.218-27.74 13.283-37.448 2.343-11.031 14.591-19.992 14.591-19.992l-2.15-5.086 11.335-9.457z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint42_linear_0_407)",
                d: "M24.496 424.261s4.302-6.825 4.809-9.478c.506-2.657 1.916-7.349 4.568-5.934 0 0 1.249 12.904.822 17.942-.433 5.043 5.7 4.878 5.7 4.878s1.691.235 2.924 1.473c.854.854.245 2.337-.96 2.412-2.007.128-5.193.166-8.54-.486a2.612 2.612 0 01-2.108-2.412l-.885-14.852-5.428 6.858-.907-.411.005.01z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint43_linear_0_407)",
                d: "M53.993 341.338s-1.254 53.63-1.425 61.245c-.17 7.616 1.2 24.496 8.838 29.54l-3.325 2.46s-4.152-3.528-8.208-10.321c-4.558-7.632-5.935-9.025-5.935-9.025l1.51-3.095a6.777 6.777 0 00.55-4.366c-1.649-7.984-7.15-34.55-8.656-40.266-1.772-6.751-1.9-15.771 4.27-23.317 6.164-7.546 12.376-2.85 12.376-2.85l.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint44_linear_0_407)",
                d: "M46.943 437a.468.468 0 01-.47-.4c-.256-1.788-1.313-8.956-2.177-10.813-.993-2.124-4.232-11.074 0-11.832 0 0 10.524 15.37 12.541 17.447 2.018 2.07 4.569.725 4.569.725s1.969.582 3.453 2.477c.704.902.048 2.225-1.1 2.236l-7.087.069a4.984 4.984 0 01-4.675-3.143c-1.249-3.117-3.389-7.685-5.887-9.713l1.297 12.424a.476.476 0 01-.464.523z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint45_linear_0_407)",
                d: "M62.793 276.218s-1.596 5.091.854 13.475l15.22 53.149a1.647 1.647 0 01-1.03 2.002c-4.552 1.633-19.516 6.254-39.946 4.846a2.319 2.319 0 01-2.113-1.804c-1.345-6.058-5.94-26.732-6.884-30.981-3.603-16.186-7.093-31.578 10.604-42.134 8.155 3.496 15.231 3.491 23.295 1.447z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint46_linear_0_407)",
                d: "M44.435 228.096s-3.064 43.783 25.221 21.79c0 0 4.18-3.944 7.194-4.424 1.623-.256 3.459-.432 4.804-.534.613-.048.901.747.395 1.1-.972.683-2.247 1.419-3.352 1.531-2.135.219.139 1.783-2.183 5.871-2.321 4.088-5.64 2.546-5.64 2.546s-32.411 33.189-38.885-24.699c-.23-10.77 10.135-10.199 12.44-3.181h.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint47_linear_0_407)",
                d: "M101.854 233.069l-9.623-1.27c-1.147-.192-2.332.481-3.042 1.724l-6.33 13.993c-1.19 2.092-.34 4.862 1.586 5.182l7.728.993c.741.123 1.5-.342 1.915-1.18l8.561-17.088c.496-.987.08-2.215-.795-2.359v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint48_linear_0_407)",
                d: "M95.289 251.941s6.468-9.415 5.721-10.578c-.753-1.158-6.426-2.818-7.754-3.213-1.335-.389-3.838 8.15 2.038 13.785l-.005.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint49_linear_0_407)",
                d: "M71.46 187.301s1.377 24.347-8.864 24.688c-10.242.342-11.24-16.971-11.24-16.971s3.026-10.935 7.899-12.21c4.878-1.276 12.2 4.493 12.2 4.493h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint50_linear_0_407)",
                d: "M68.45 179.787s4.68 4.787 3.875 7.765c-.806 2.978-10.845-.139-13.316-1.543l-8.293 8.827s.256-13.075 5.977-17.099c5.721-4.024 11.757 2.055 11.757 2.055v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint51_linear_0_407)",
                d: "M54.462 195.253s-1.248-8.352-5.331-6.004c-4.083 2.348.299 8.822 3.49 8.416l1.841-2.412z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_407",
                        x1: "15.845",
                        x2: "35.687",
                        y1: "85.821",
                        y2: "85.821",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_407",
                        x1: "136.052",
                        x2: "134.451",
                        y1: "47.967",
                        y2: "102.403",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_407",
                        x1: "72.581",
                        x2: "90.227",
                        y1: "293.868",
                        y2: "297.944",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#2B3582"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#150E42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_407",
                        x1: "225.054",
                        x2: "235.018",
                        y1: "234.67",
                        y2: "183.437",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_407",
                        x1: "144.559",
                        x2: "128.196",
                        y1: "229.019",
                        y2: "254.993",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_407",
                        x1: "322.264",
                        x2: "322.264",
                        y1: "211.562",
                        y2: "258.173",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_407",
                        x1: "183.126",
                        x2: "139.863",
                        y1: "190.767",
                        y2: "301.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_407",
                        x1: "244.896",
                        x2: "201.623",
                        y1: "214.483",
                        y2: "325.313",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_407",
                        x1: "403.696",
                        x2: "433.77",
                        y1: "-321.968",
                        y2: "-410.905",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_407",
                        x1: "362.301",
                        x2: "404.601",
                        y1: "226.975",
                        y2: "159.293",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_407",
                        x1: "125.851",
                        x2: "183.05",
                        y1: "320.784",
                        y2: "276.639",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_407",
                        x1: "120.178",
                        x2: "147.622",
                        y1: "313.57",
                        y2: "314.279",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_407",
                        x1: "279.339",
                        x2: "336.545",
                        y1: "319.245",
                        y2: "275.11",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_407",
                        x1: "273.687",
                        x2: "301.131",
                        y1: "312.245",
                        y2: "312.954",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_407",
                        x1: "301.183",
                        x2: "283.038",
                        y1: "233.219",
                        y2: "249.229",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_407",
                        x1: "429.951",
                        x2: "346.435",
                        y1: "256.701",
                        y2: "300.084",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_407",
                        x1: "332.186",
                        x2: "335.388",
                        y1: "32.543",
                        y2: "88.574",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_407",
                        x1: "228.95",
                        x2: "231.069",
                        y1: "378.156",
                        y2: "271.345",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_407",
                        x1: "417.66",
                        x2: "338.349",
                        y1: "276.729",
                        y2: "397.277",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_407",
                        x1: "423.915",
                        x2: "420.744",
                        y1: "322.989",
                        y2: "437.987",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_407",
                        x1: "393.756",
                        x2: "453.603",
                        y1: "274.712",
                        y2: "276.217",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_407",
                        x1: "424.811",
                        x2: "447.208",
                        y1: "275.14",
                        y2: "277.01",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_407",
                        x1: "414.794",
                        x2: "376.545",
                        y1: "286.821",
                        y2: "306.562",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_407",
                        x1: "423.53",
                        x2: "430.932",
                        y1: "362.108",
                        y2: "344.417",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_407",
                        x1: "206.85",
                        x2: "210.052",
                        y1: "39.7",
                        y2: "95.736",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_407",
                        x1: "374.475",
                        x2: "421.348",
                        y1: "357.199",
                        y2: "357.199",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_407",
                        x1: "393.247",
                        x2: "401.177",
                        y1: "303.061",
                        y2: "395.057",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_407",
                        x1: "406.486",
                        x2: "382.663",
                        y1: "343.237",
                        y2: "382.27",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_407",
                        x1: "151.496",
                        x2: "198.369",
                        y1: "357.972",
                        y2: "357.972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_407",
                        x1: "171.878",
                        x2: "179.809",
                        y1: "322.136",
                        y2: "414.137",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_407",
                        x1: "183.552",
                        x2: "159.723",
                        y1: "343.79",
                        y2: "382.824",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_407",
                        x1: "283.541",
                        x2: "330.415",
                        y1: "358.102",
                        y2: "358.102",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_407",
                        x1: "302.974",
                        x2: "310.904",
                        y1: "310.834",
                        y2: "402.83",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_407",
                        x1: "315.623",
                        x2: "291.799",
                        y1: "343.795",
                        y2: "382.828",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_407",
                        x1: "97.883",
                        x2: "144.757",
                        y1: "357.972",
                        y2: "357.972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_407",
                        x1: "118.66",
                        x2: "126.59",
                        y1: "326.728",
                        y2: "418.729",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_407",
                        x1: "129.942",
                        x2: "106.113",
                        y1: "343.793",
                        y2: "382.826",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_407",
                        x1: "82.427",
                        x2: "61.833",
                        y1: "137.114",
                        y2: "188.401",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_407",
                        x1: "85.939",
                        x2: "74.188",
                        y1: "227.396",
                        y2: "270.875",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_407",
                        x1: "158.76",
                        x2: "137.151",
                        y1: "112.628",
                        y2: "139.846",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_407",
                        x1: "59.25",
                        x2: "53.219",
                        y1: "226.304",
                        y2: "206.157",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_407",
                        x1: "116.413",
                        x2: "93.464",
                        y1: "459.687",
                        y2: "430.868",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_407",
                        x1: "24.346",
                        x2: "43.472",
                        y1: "422.38",
                        y2: "422.2",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_407",
                        x1: "44.381",
                        x2: "100.653",
                        y1: "368.657",
                        y2: "487.001",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_407",
                        x1: "42.112",
                        x2: "64.915",
                        y1: "425.665",
                        y2: "425.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_407",
                        x1: "87.3",
                        x2: "39.962",
                        y1: "267.732",
                        y2: "333.823",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint46_linear_0_407",
                        x1: "63.354",
                        x2: "113.669",
                        y1: "244.213",
                        y2: "244.213",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint47_linear_0_407",
                        x1: "88.742",
                        x2: "97.867",
                        y1: "234.501",
                        y2: "244.983",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint48_linear_0_407",
                        x1: "98.923",
                        x2: "92.727",
                        y1: "231.997",
                        y2: "254.908",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint49_linear_0_407",
                        x1: "70.258",
                        x2: "35.166",
                        y1: "191.642",
                        y2: "214.341",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint50_linear_0_407",
                        x1: "82.214",
                        x2: "61.566",
                        y1: "136.558",
                        y2: "187.973",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint51_linear_0_407",
                        x1: "65.326",
                        x2: "30.234",
                        y1: "184.015",
                        y2: "206.714",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsCarWarranty/index.tsx




function WhatIsCarWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:mt-28 mt-14 lg:mb-48 mb-20 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 order-1 lg:order-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "What Is a Car Warranty For?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                        children: "A car warranty is a contract between the car manufacturer or dealership and the vehicle owner that provides coverage for certain repairs and services. It is designed to protect the owner from unexpected expenses related to mechanical breakdowns and failures. A car warranty typically covers the cost of repairs, parts replacements, and labor for specified components and systems of the vehicle. Depending on the type of warranty, it may provide coverage for a specific period of time or a certain number of miles driven. Having a car warranty gives owners the comfort of knowing that they can rely on the warranty provider to address and cover the cost of qualified repairs, reducing the financial burden associated with unforeseen vehicle issues."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[250px] h-[250px] md:h-[437px] md:w-[440px] md:min-w-[440px] relative mx-auto lg:mt-16 order-2 lg:order-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 30893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhatIsHomeWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsHomeWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 437 434",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_53)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M174.953 309.406S133.898 127.383 43.097 27.867c-6.104-6.688-17.594-4.155-20.232 4.49C5.198 90.18-30.036 265.62 174.953 309.406z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M156.349 297.621c.45.434-.173 1.12-.686.748-18.818-13.721-91.287-81.073-115.796-214.93-.078-.429.581-.591.702-.173 8.632 31.039 44.185 145.496 115.78 214.355z",
                        opacity: "0.24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M176.298 223.439S160.039 84.685 98.977 3.553C94.873-1.9 85.89-.9 83.157 5.338c-18.279 41.704-59.706 169.668 93.136 218.101h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M163.075 213.224c.309.361-.225.822-.581.502-13.228-11.67-62.962-67.435-70.584-169.034-.026-.325.492-.398.55-.073 4.02 23.785 21.671 111.788 70.621 168.6l-.006.005z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M420.38 165.528H330.7v221.059h89.68V165.528z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_53)",
                        d: "M432.388 180.469H326.423l-19.394-77.918h102.667l26.864 71.382c1.414 3.051-.811 6.536-4.172 6.536z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_53)",
                        d: "M409.701 103.624l-115.618.466-3.203-9.603 111.723.601c3.916 0 7.093 2.319 7.093 5.176v3.36h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.89",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                d: "M400.845 231.331H350.77a.586.586 0 00-.586.586v77.814c0 .324.262.586.586.586h50.075a.586.586 0 00.586-.586v-77.814a.587.587 0 00-.586-.586z",
                                opacity: "0.71"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#91B3FA",
                                d: "M373.493 235.602h-19.248a.324.324 0 00-.324.324v69.796c0 .179.145.325.324.325h19.248c.18 0 .325-.146.325-.325v-69.796a.324.324 0 00-.325-.324zM397.369 235.602h-19.248a.325.325 0 00-.325.324v69.796c0 .179.146.325.325.325h19.248a.325.325 0 00.324-.325v-69.796a.324.324 0 00-.324-.324z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M106.295 386.587h-84.35a5.33 5.33 0 01-5.33-5.328V165.528h89.68v221.059z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_53)",
                        d: "M4.607 180.469h105.965l37.826-82.79-121.104 4.872-26.86 71.387c-1.413 3.051.812 6.536 4.173 6.536v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_53)",
                        d: "M27.294 103.624l122.7-1.937 9.606-8.001-124.669 1.402c-4.219 0-7.642 2.319-7.642 5.176v3.36h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.89",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                d: "M35.104 310.317H85.18a.587.587 0 00.586-.586v-77.814a.587.587 0 00-.586-.586H35.104a.587.587 0 00-.586.586v77.814c0 .323.262.586.586.586z",
                                opacity: "0.71"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#91B3FA",
                                d: "M62.46 306.047h19.248c.18 0 .325-.146.325-.325v-69.796a.324.324 0 00-.325-.324H62.46a.324.324 0 00-.324.324v69.796c0 .179.145.325.324.325zM38.58 306.047h19.248c.179 0 .324-.146.324-.325v-69.796a.324.324 0 00-.324-.324H38.58a.324.324 0 00-.325.324v69.796c0 .179.146.325.325.325z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M218.5 57.383S96.92 149.148 93.905 149.148l-1.356 236.648 250.217 1.57.329-238.218L218.5 57.383z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M235.57 215.569h-45.285a3.72 3.72 0 01-3.722-3.721v-3.25a3.724 3.724 0 013.466-3.716l45.285-3.145a3.723 3.723 0 013.983 3.716v6.395a3.719 3.719 0 01-3.721 3.721h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M171.158 334.683h80.959c.916 0 1.66.743 1.66 1.659v15.438h-84.278v-15.438a1.66 1.66 0 011.659-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M167.583 349.859h90.816a1.66 1.66 0 011.659 1.659v15.962h-94.135v-15.962a1.66 1.66 0 011.66-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M160.254 367.129h109.661a1.66 1.66 0 011.659 1.659v17.532H158.595v-17.532a1.66 1.66 0 011.659-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_53)",
                        d: "M188.427 221.446h49.007c1.026 0 1.863.837 1.863 1.863V336.08h-52.734V223.309c0-1.026.838-1.863 1.864-1.863z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M205.607 296.642h-7.957a4.814 4.814 0 01-4.81-4.809v-58.822a4.814 4.814 0 014.81-4.809h7.957a4.814 4.814 0 014.811 4.809v58.822a4.814 4.814 0 01-4.811 4.809zm-7.957-67.865a4.24 4.24 0 00-4.234 4.234v58.822a4.24 4.24 0 004.234 4.234h7.957a4.24 4.24 0 004.235-4.234v-58.822a4.24 4.24 0 00-4.235-4.234h-7.957zM227.818 296.642h-7.957a4.813 4.813 0 01-4.81-4.809v-58.822a4.813 4.813 0 014.81-4.809h7.957a4.814 4.814 0 014.811 4.809v58.822a4.814 4.814 0 01-4.811 4.809zm-7.957-67.865a4.24 4.24 0 00-4.234 4.234v58.822a4.24 4.24 0 004.234 4.234h7.957a4.24 4.24 0 004.235-4.234v-58.822a4.24 4.24 0 00-4.235-4.234h-7.957zM205.607 330.601h-7.957c-2.653 0-4.81-4.019-4.81-8.959v-12.597c0-4.94 2.157-8.959 4.81-8.959h7.957c2.654 0 4.811 4.019 4.811 8.959v12.597c0 4.94-2.157 8.959-4.811 8.959zm-7.957-29.442c-2.334 0-4.234 3.537-4.234 7.881v12.597c0 4.348 1.9 7.886 4.234 7.886h7.957c2.335 0 4.235-3.538 4.235-7.886V309.04c0-4.349-1.9-7.881-4.235-7.881h-7.957zM227.818 330.601h-7.957c-2.654 0-4.81-4.019-4.81-8.959v-12.597c0-4.94 2.156-8.959 4.81-8.959h7.957c2.654 0 4.811 4.019 4.811 8.959v12.597c0 4.94-2.157 8.959-4.811 8.959zm-7.957-29.442c-2.334 0-4.234 3.537-4.234 7.881v12.597c0 4.348 1.9 7.886 4.234 7.886h7.957c2.335 0 4.235-3.538 4.235-7.886V309.04c0-4.349-1.9-7.881-4.235-7.881h-7.957z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M281.17 195.002h-.503c-13.024 0-24.425 9.216-24.425 22.236v23.45h24.928v-45.686zM256.242 247.612v68.985c0 2.324 2.727 5.924 5.052 5.924h19.876v-74.909h-24.928zM287.98 195.002h-1.267v45.686h24.927v-23.45c0-13.02-10.636-22.236-23.66-22.236zM286.713 322.521h20.64c2.324 0 4.287-3.6 4.287-5.924v-68.985h-24.927v74.909z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M313.792 326.828h-60.005c-3.439 0-6.24-2.8-6.24-6.238V216.725c0-16.427 13.364-29.787 29.796-29.787h12.893c16.432 0 29.796 13.36 29.796 29.787V320.59c0 3.438-2.801 6.238-6.24 6.238zm-36.449-139.315c-16.112 0-29.22 13.104-29.22 29.212V320.59a5.67 5.67 0 005.664 5.662h60.005a5.67 5.67 0 005.664-5.662V216.725c0-16.108-13.108-29.212-29.22-29.212h-12.893z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M143.875 195.002h-.503c-13.024 0-24.425 9.216-24.425 22.236v23.45h24.928v-45.686zM118.947 247.612v68.985c0 2.324 2.728 5.924 5.052 5.924h19.876v-74.909h-24.928zM150.68 195.002h-1.267v45.686h24.928v-23.45c0-13.02-10.637-22.236-23.661-22.236zM149.413 322.521h20.64c2.325 0 4.288-3.6 4.288-5.924v-68.985h-24.928v74.909z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M176.523 326.828h-60.004c-3.44 0-6.24-2.8-6.24-6.238V216.725c0-16.427 13.364-29.787 29.795-29.787h12.893c16.432 0 29.796 13.36 29.796 29.787V320.59c0 3.438-2.8 6.238-6.24 6.238zm-36.449-139.315c-16.112 0-29.219 13.104-29.219 29.212V320.59a5.67 5.67 0 005.664 5.662h60.004a5.67 5.67 0 005.664-5.662V216.725c0-16.108-13.107-29.212-29.22-29.212h-12.893z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_53)",
                        d: "M293.67 59.387h-20.614v33.55h20.614v-33.55z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_53)",
                        d: "M270.339 54.52h25.268a4.86 4.86 0 014.858 4.856v5.448h-33.314v-7.112a3.195 3.195 0 013.194-3.192h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_53)",
                        d: "M86.267 158.767L218.5 57.383l125.522 97.333c4.565 3.538 11.255 1.063 12.411-4.595l1.759-8.608L218.5 35.131 83.284 138.378a6.733 6.733 0 00-2.141 7.907l5.124 12.477v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint8_linear_0_53)",
                        d: "M386.161 275.113c2.68 2.857 6.627 5.332 9.401 6.871-4.146 5.123-9.757 10.257-17.185 15.276l-2.125 4.767-6.811-8.158s12.223-6.081 16.72-18.756z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint9_linear_0_53)",
                        d: "M349.712 429.897c0-.146.005-.293.047-.445 2.204-8.745 13.155-14.187 13.155-14.187l4.339.34c2.497 7.709 2.173 12.434 1.775 14.538-.011.058-.032.115-.047.173-3.581.319-10.946.528-19.269-.419z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M368.975 430.316c-.193.701-.712 1.251-1.376 1.392-5.094 1.073-13.186.209-16.584-.236-.748-.099-1.298-.79-1.308-1.575 8.323.947 15.688.738 19.268.419z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint10_linear_0_53)",
                        d: "M368.991 409.142l-1.837 8.844c-.137.649-.634 1.136-1.236 1.188-.738.068-1.79.11-2.847-.047-.948-.141-1.607-1.104-1.44-2.135l1.277-7.855h6.083v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M330.919 430.227c4.79-.136 7.271-.696 8.554-1.225 0 .477 0 .963-.016 1.466-.016.534-.414.963-.9.963l-26.31-.168c-.837-.005-1.329-.978-.968-1.748 3.449.283 12.233.921 19.645.717l-.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint11_linear_0_53)",
                        d: "M311.274 429.51c.031-.068.057-.136.104-.199 2.325-3.245 8.24-9.708 19.934-12.513l5.612-.178s2.497 4.339 2.544 12.382c-1.283.524-3.759 1.089-8.554 1.225-7.407.209-16.196-.429-19.645-.717h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint12_linear_0_53)",
                        d: "M337.965 408.122c-.063.418-.832 6.771-1.13 9.236-.074.586-.498 1.036-1.032 1.104-.958.116-2.502.22-3.852-.057-.728-.152-1.257-.848-1.257-1.664v-9.975l7.271 1.361v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint13_linear_0_53)",
                        d: "M342.467 292.168s-13.531 51.406-13.285 116.1c0 1.177.832 2.198 1.989 2.439 1.701.356 4.203.785 6.271.727a2.32 2.32 0 002.214-1.941c1.895-11.121 12.783-73.784 18.986-83.958 0 0 4.083 55.808 2.775 84.764a1.374 1.374 0 001.209 1.428c1.089.126 2.821.22 5.036-.016a1.838 1.838 0 001.638-1.559c1.351-9.415 9.129-65.447 8.799-105.811-.02-2.277-6.019-12.173-6.019-12.173h-29.613z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint14_linear_0_53)",
                        d: "M323.649 229.95a56.155 56.155 0 005.726-8.74c2.246-4.244.184 2.748.796-2.046 16.829-12.141 42.176-5.997 51.98-4.762a13.08 13.08 0 018.271 4.438c8.402 9.718 26.833 36.329 5.135 63.139-2.774-1.539-6.721-4.014-9.401-6.871 2.402-6.767 2.596-15.412-2.434-26.01a24.013 24.013 0 01-.644 2.491c-6.936 21.959-7.303 40.234-7.287 44.447 0 .57-.34 1.088-.874 1.297-9.124 3.658-26.692 1.481-32.591.602a1.979 1.979 0 01-1.659-2.25c2.894-20.959-11.962-55.441-15.882-64.081a5.622 5.622 0 00-1.147-1.659l.011.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint15_linear_0_53)",
                        d: "M366.379 196.75l1.759 17.966s-10.108 3.046-17.463-2.141l5.166-16.327 10.533.502h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_53)",
                        d: "M354.648 176.278c-.241.23-10.265 19.907-10.265 19.907l11.359 5.484 12.275-17.243s-9.296-11.984-13.369-8.154v.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_53)",
                        d: "M362.987 184.907c.204.523.151 1.11-.136 1.591l-5.67 9.446a1.815 1.815 0 01-.308.387c-.676.628-2.984 2.455-4.769-.031-1.523-2.12-2.947-4.045-4.476-4.841-.895-.466-1.989-.094-2.444.806-.932 1.853-2.743 5.621-3.879 9.195a1.808 1.808 0 001.052 2.214c2.298.931 6.847 2.616 10.883 3.171a1.8 1.8 0 001.711-.728c1.738-2.375 6.628-9.022 8.297-10.686 1.55-1.544 4.413-.963 5.706-.591a1.83 1.83 0 001.45-.189c1.309-.79 3.591-2.752 1.503-6.075-.519-.827-.257-1.926.56-2.465 1.46-.963 3.046-2.763 1.539-5.689-1.529-2.957-4.261-3.224-6.12-2.993-.822.099-1.659-.33-1.973-1.099-.141-.34-.419-.633-.937-.738-.974-.199-1.618-1.089-1.424-2.067.33-1.675.079-3.847-2.591-5.317-4.905-2.695-9.197 1.695-10.286 5.4-1.094 3.706 4.386 6.327 7.836 6.762 2.534.319 3.921 3.082 4.481 4.527l-.005.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_53)",
                        d: "M361.123 198.896s2.178-6.375 4.968-6.144c2.79.235 4.988 3.014 1.528 6.138-4.303 3.889-6.496.006-6.496.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_53)",
                        d: "M384.648 247.455c3.68-10.063 2.345-22.215 2.329-22.335l-1.015.115c.015.12 1.319 12.036-2.277 21.87l.958.35h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_53)",
                        d: "M359.14 324.227a.508.508 0 00.492-.382c1.12-4.328 9.521-9.08 9.61-9.127a.508.508 0 00.194-.696.506.506 0 00-.696-.193c-.361.204-8.868 5.013-10.098 9.76a.51.51 0 00.498.638z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_53)",
                        d: "M307.839 281.675c14.233-12.957 12.747-30.159 12.93-41.923.241-15.538 10.616-21.451 10.616-21.451l9.276 17.646c1.947 26.643-12.762 49.156-25.299 55.148-3.843-2.878-6.151-6.405-7.523-9.42z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_53)",
                        d: "M282.143 295.256l6.621-2.753c8.355-2.962 14.521-6.678 19.076-10.828 1.371 3.015 3.68 6.542 7.522 9.42-7.983 3.815-14.668 4.841-14.668 4.841-15.641 5.709-18.551-.68-18.551-.68z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_53)",
                        d: "M277.306 315.289a4.646 4.646 0 01-.592-3.988l4.089-13.188s-1.152-1.188-3.848.356c-2.696 1.544-4.789-1.031-4.789-1.031s3.905-1.931 9.788-4.621c3.366-1.539 6.784-1.157 9.098-.544l1.283 5.296c-3.146 7.619-7.837 14.103-13.652 19.755l-1.377-2.035z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_53)",
                        d: "M312.74 301.086s4.177 1.444 5.014 7.211c.838 5.767-4.177 10.095-8.359 9.373-4.178-.722-8.659-11.534-.985-16.579s4.33 0 4.33 0v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_53)",
                        d: "M277.16 186.582s-5.963 4.589-14.239 8.017c-4.617 1.91-13.594 4.736-14.782 12.989-.613 4.26-4.267 7.672-9.187 8.321-12.255 1.617-31.136 7.107-34.156 25.455-2.309 14.004 5.972 19.316 14.657 21.152 6.381 1.351 10.621 6.704 9.328 12.257-1.236 5.327.607 11.487 11.312 16.359 23.985 10.917 47.939-25.863 47.939-25.863l4.91-64.212-15.782-14.475z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M222.437 254.274c-.362 0-.775-.152-1.11-.335-5.596-3.145-8.58-9.634-7.255-15.789.79-3.684 2.91-6.86 5.962-8.943 2.162-1.476 4.732-2.381 7.182-3.182a154.233 154.233 0 0112.657-3.527c.351-.084.702-.162 1.047-.241 2.497-.576 5.083-1.167 7.418-2.177 2.999-1.293 5.182-3.177 6.156-5.301.602-1.319.774-2.779.942-4.192.204-1.727.419-3.517 1.418-5.045a.068.068 0 01.089-.021.067.067 0 01.021.089c-.984 1.502-1.198 3.276-1.397 4.987-.168 1.424-.346 2.894-.953 4.229-.984 2.156-3.193 4.061-6.219 5.369-2.35 1.015-4.936 1.607-7.443 2.182-.351.079-.702.163-1.047.241a152.044 152.044 0 00-12.647 3.527c-2.44.796-4.999 1.696-7.151 3.161-3.026 2.067-5.119 5.213-5.905 8.865-1.313 6.092 1.644 12.529 7.193 15.643.424.24 1.235.528 1.591.099.021-.026.063-.031.094-.01.027.021.032.062.011.094-.157.193-.393.267-.649.267l-.005.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M220.997 248.476s-.037-.011-.053-.027c-2.156-2.784-3.282-5.709-3.25-8.451.036-3.214 1.764-6.202 4.512-7.798.031-.021.068-.005.089.021.015.031.005.073-.026.089-2.707 1.57-4.408 4.516-4.445 7.688-.031 2.716 1.084 5.61 3.225 8.373.021.026.016.068-.011.094a.056.056 0 01-.041.016v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_53)",
                        d: "M302.652 241.249s13.375 33.163 17.552 62.72l-4.177 3.606s-13.375-37.486-23.404-48.303l10.029-18.023z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_53)",
                        d: "M214.323 423.774l-.906 6.427c-.173 1.219-1.288 2.182-2.701 2.323-2.387.236-6.224.477-9.977.137-1.649-.152-2.717-1.591-2.215-2.952.916-2.481 2.586-6.207 5-8.399h8.27c1.529 0 2.712 1.151 2.529 2.464z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_53)",
                        d: "M279.086 348.468l1.398 7.08s-4.675 40.83-5.507 57.163c-.131 2.559.638 5.092 2.193 7.274l8.124 11.383-20.651-10.514-.413-2.172 3.381-4.008-4.428-45.739c-.262-2.685.382-5.38 1.853-7.761l4.271-6.924 9.774-5.777.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_53)",
                        d: "M286.655 433.016h-6.59c-1.235 0-2.398-.486-3.151-1.329-2.058-2.303-6.313-6.793-8.35-6.913-2.737-.157-2.387 8.242-2.387 8.242h-1.533l-1.948-10.44c-.492-2.627 1.026-5.228 3.759-6.458 0 0 .628 3.993 4.025 5.762 3.398 1.769 13.82 8.096 13.82 8.096s1.277-.157 2.68.063c2.078.324 1.79 2.977-.325 2.977z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_53)",
                        d: "M250.798 351.833s-27.377 44.791-31.733 55.022c-4.35 10.226-5.878 18.761-5.936 19.567-.089 1.262-1.91 2.476-6.93 2.476-2.592 0-3.858-.895-4.481-1.764-.529-.738-.555-1.664-.11-2.444 1.586-2.763 6.611-11.597 8.47-15.606 2.224-4.783 7.003-26.464 9.626-34 2.623-7.536 5.585-15.716 17.002-23.246 0 0 7.837-6.62 14.087 0l.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_53)",
                        d: "M268.093 278.436c7.062-25.81-10.83-40.411-10.83-40.411 11.291-9.347 31.858-13.601 31.858-13.601s19.625 12.376 17.3 22.063c-1.366 5.678-13.793 34.006-13.793 34.006s-11.495 4.694-24.53-2.062l-.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_53)",
                        d: "M252.436 291.216c2.874-7.468 15.657-12.78 15.657-12.78 13.034 6.751 24.53 2.062 24.53 2.062s2.575 8.499.801 16.396c-1.78 7.897-12.941 58.654-12.941 58.654-17.588 3.072-44.641-3.093-44.641-3.093 11.202-17.154 13.72-53.777 16.594-61.245v.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_53)",
                        d: "M276.291 207.368l-5.743 22.247c-.549 1.957 1.524 1.638 3.816 1.266 3.764-.612 8.611-1.873 10.229-4.396.167-.256.246-.549.293-.837l2.466-15.428c.193-1.224-.571-2.412-1.88-2.914l-4.758-1.822c-1.832-.701-3.952.199-4.423 1.884z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_53)",
                        d: "M294.376 192.746s4.366 5.574 3.45 14.989c-.911 9.414-6.083 10.874-10.077 9.074-3.994-1.8-9.459-5.223-12.16-13.313-2.701-8.086 12.951-17.757 18.787-10.75z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_53)",
                        d: "M282.096 202.13s2.722-12.932 13.641-6.458l1.518 3.051s7.905-3.276 3.256-9.969c-4.648-6.694-13.835-9.096-21.708-3.397-7.873 5.699-11.757 10.362-9.579 16.71 2.183 6.348 6.847 3.501 6.847 3.501s-.236-4.841 2.01-5.987c2.246-1.146 3.135 2.428 3.135 2.428l.88.121z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_53)",
                        d: "M280.395 204.317s1.444-6.636-2.948-6.316c-4.397.319-.978 6.342.487 8.514l2.466-2.198h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M299.48 287.118s-1.037-5.506 3.209-6.688c0 0-1.922-6.348 4.088-6.327 0 0 10.276-12.769 18.562.319 0 0 18.546 1.125 11.213 15.166 0 0 4.863 4.349-2.215 7.855 0 0-5.716 17.186-18.604 6.107l-16.248-16.427-.005-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_53)",
                        d: "M358.04 274.731c-3.848-3.951-6.632 1.355-6.632 1.355-3.099 1.042 0 7.698 0 7.704-1.895 3.673-11.789 22.555-17.149 27.213-5.947 5.165 3.617 6.515 3.617 6.515s10.689-4.998 16.683-32.211c.052-.021.099-.036.141-.073.817-.623 7.193-6.552 3.34-10.503z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_53)",
                        d: "M297.993 314.153c-3.894-5.066-9.192-24.193-11.055-31.243.848-1.235 3.742-5.819 1.303-7.232 0 0-1.675-5.751-6.234-2.643-4.204 2.868-.215 9.106.958 10.66-.069 15.616 7.333 34.66 7.333 34.66s12.49 2.036 7.69-4.207l.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint40_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M315.273 427.103s.864 3.202.801 5.568a.758.758 0 01-.654.732c-2.162.299-9.543 1.183-13.595 0a.748.748 0 01-.539-.737c.037-1.272.932-4.26 8.339-5.019l5.648-.539v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint41_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M302.531 378.135c-.91.596 5.963 48.858 7.627 49.208 0 0 1.906 1.769 4.848-.246-1.696-15.731-2.733-31.687-1.817-47.989l-10.658-.973z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint42_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M331.736 427.103s.864 3.202.801 5.568a.758.758 0 01-.655.732c-2.161.299-9.542 1.183-13.594 0a.745.745 0 01-.539-.737c.037-1.272.932-4.26 8.339-5.019l5.648-.539v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint43_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M318.995 378.135c-.911.596 5.962 48.858 7.627 49.208 0 0 1.905 1.769 4.847-.246-1.696-15.731-2.732-31.687-1.816-47.989l-10.658-.973z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint44_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M326.643 348.839s-22.42 1.026-27.76 2.899c0 0 .66 18.223 2.848 29.422.084.434.414.78.843.879 1.439.335 5.062.811 10.799-.796a1.12 1.12 0 00.811-1.156l-.591-7.259a.885.885 0 01.822-.942l.602-.089a.887.887 0 01.947.874l1.136 7.364c0 .476.309.9.759 1.051 1.686.571 6.072 1.639 11.856-.125a1.11 1.11 0 00.791-1.057c.057-8.933-1.544-19.625-3.863-31.06v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint45_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M318.236 350.409s2.832 7.876 9.673 8.426l-1.512-8.986s-5.298-.042-8.161.56z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint46_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M337.154 307.386s-10.134 6.511-22.441 5.788c-12.307-.722-17.541-5.5-20.436-9.121-.047.021-3.46.926-7.622 5.149a2.068 2.068 0 00-.345 2.449c2.732 4.988 6.224 8.709 7.799 11.859a6.615 6.615 0 011.712 4.616l-.623 23.712c-.016.659.44 1.23 1.084 1.35 4.496.853 21.566 3.825 32.182 1.952v-25.575a5.176 5.176 0 012.67-4.532c2.23-1.23 5.57-3.653 8.909-8.248l-2.894-9.409.005.01z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint47_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M319.576 301.912l1.109 12.21s-6.443 3.768-11.992.471l.984-10.666 9.893-2.02.006.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint48_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M307.803 279.347s-19.473 14.559-8.475 25.072c10.38 9.922 20.106-.89 20.106-.89s7.439-3.689 7.161-8.666c-.277-4.982-14.856-16.783-18.792-15.511v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint49_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M322.083 300.368c-.712-.34-1.351-.936-1.822-1.816-.701-1.308-.78-2.904-.382-4.333.105-.366.231-.785.032-1.109-.241-.393-.786-.408-1.246-.455a4.175 4.175 0 01-3.288-2.35c-.591-1.277-.465-2.863.325-4.025-1.879-.486-2.083-1.962-3.418-2.883-1.225-.848-2.984-.126-4.329-.68-.99-.409-3.052-1.921-2.769-3.245.125-.591 1.837-1.853 2.392-2.245 2.481-1.753 5.193-1.23 7.386.754 6.334 5.719 12.008 11.262 13.217 14.161.848 2.03.791 4.647-.549 6.452-1.387 1.874-3.727 2.654-5.554 1.78l.005-.006z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint50_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M317.199 304.649l4.361-5.264s4.952-.435 3.219 2.653c-1.738 3.093-6.208 3.548-7.58 2.611z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint51_linear_0_53)",
                        d: "M261.979 238.543c-2.088-.979-4.695-.67-6.517.649-3.617 2.632-11.925 10.508-12.793 27.72-1.115 22.074 37.83 16.313 37.83 16.313l2.225-4.799s-27.817-.958-27.817-10.556c0-6.761 8.077-14.616 11.668-17.772 1.377-1.209 1.979-2.957 1.476-4.595-.858-2.784-3.277-5.657-6.072-6.96z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint52_linear_0_53)",
                        d: "M277.62 278.436s3.989-1.92 7.329-2.883c3.34-.958 4.449 0 4.449 0s-3.339.957-4.449 1.92c-1.11.963 5.329.968 7.669.963 2.345 0 2.758 4.715.324 6.196-2.434 1.481-9.108 4.36-15.782-1.402l.46-4.794z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint53_linear_0_53)",
                        d: "M127.71 389.559s-34.329 17.563-50.305-1.366c-12.84-15.213 9.376-4.118 30.602-1.005 1.665.246 2.131-2.208.492-2.59-16.107-3.758-40.14-10.932-41.186-20.462-1.576-14.386 2.894-8.227 20.912.57s23.363 5.542 12.255-1.931c-11.108-7.473-32.9-8.446-35.188-16.055-2.287-7.615-.33-20.269-.225-25.994.105-5.72 28.01-3.831 32.288 5.343 4.271 9.174 4.192 26.025 11.212 31.761 7.02 5.73 3.308-10.603.529-19.358-2.785-8.761-3.005-14.569 7.04-8.938 10.041 5.631 10.763 20.749 8.224 30.871-2.539 10.121-.837 16.966.806 12.104 1.644-4.862 5.46-20.237 3.727-25.946-1.732-5.71 20.525 8.865-1.167 43.001l-.016-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M125.643 389.067a.346.346 0 01-.304-.178c-13.929-26.051-43.83-52.448-44.128-52.709a.341.341 0 11.45-.513c.304.262 30.288 26.742 44.28 52.903a.34.34 0 01-.141.461.357.357 0 01-.157.041v-.005z",
                        opacity: "0.53"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint54_linear_0_53)",
                        d: "M147.11 399.204s-42.16-2.156-46.929-28.851c-3.832-21.456 11.145 1.23 29.555 15.81 1.445 1.146 3.23-.927 1.884-2.183-13.207-12.387-32.052-32.352-27.822-41.955 6.392-14.501 7.25-6.212 19.51 11.995 12.259 18.207 19.101 18.05 12.673 4.883-6.434-13.167-26.556-26.025-24.551-34.493 2.005-8.467 10.799-19.389 14.034-24.758 3.235-5.364 28.65 11.712 27.671 22.754-.979 11.037-10.292 26.967-6.779 36.24 3.512 9.279 8.946-8.237 11.108-18.06 2.162-9.823 5.14-15.454 11.574-4.616 6.433 10.839-1.173 25.56-9.13 33.766-7.956 8.2-10.092 15.621-5.873 11.91 4.225-3.71 16.264-16.191 17.751-22.55 1.487-6.358 14.599 19.646-24.676 40.119v-.011z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M145.414 397.603a.376.376 0 01-.189-.335c1.073-32.321-12.793-73.716-12.935-74.13a.367.367 0 01.236-.471.367.367 0 01.471.236c.141.413 14.05 41.939 12.977 74.396a.375.375 0 01-.56.314v-.01z",
                        opacity: "0.53"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_53",
                        x1: "394.704",
                        x2: "454.349",
                        y1: "94.387",
                        y2: "-24.939",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_53",
                        x1: "346.058",
                        x2: "352.583",
                        y1: "-6.432",
                        y2: "153.497",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_53",
                        x1: "152.941",
                        x2: "212.591",
                        y1: "-26.459",
                        y2: "-145.785",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_53",
                        x1: "87.738",
                        x2: "94.665",
                        y1: "33.378",
                        y2: "112.583",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_53",
                        x1: "45.516",
                        x2: "240.637",
                        y1: "431.901",
                        y2: "253.924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_53",
                        x1: "324.779",
                        x2: "376.58",
                        y1: "-8.53",
                        y2: "-114.51",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_53",
                        x1: "357.004",
                        x2: "324.043",
                        y1: "-48.989",
                        y2: "0.468",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_53",
                        x1: "-114.288",
                        x2: "243.813",
                        y1: "261.349",
                        y2: "112.531",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_53",
                        x1: "395.562",
                        x2: "369.441",
                        y1: "288.568",
                        y2: "288.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_53",
                        x1: "360.029",
                        x2: "359.375",
                        y1: "370.426",
                        y2: "442.473",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_53",
                        x1: "363.851",
                        x2: "367.591",
                        y1: "400.627",
                        y2: "433.273",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_53",
                        x1: "325.91",
                        x2: "325.256",
                        y1: "370.118",
                        y2: "442.164",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_53",
                        x1: "333.374",
                        x2: "337.115",
                        y1: "404.123",
                        y2: "436.763",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_53",
                        x1: "288.917",
                        x2: "408.541",
                        y1: "254.844",
                        y2: "440.513",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_53",
                        x1: "388.37",
                        x2: "363.254",
                        y1: "207.436",
                        y2: "250.355",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_53",
                        x1: "355.585",
                        x2: "369.863",
                        y1: "191.946",
                        y2: "253.663",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_53",
                        x1: "358.108",
                        x2: "351.072",
                        y1: "179.99",
                        y2: "221.416",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_53",
                        x1: "365.514",
                        x2: "344.767",
                        y1: "199.598",
                        y2: "177.552",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_53",
                        x1: "364.218",
                        x2: "365.47",
                        y1: "225.203",
                        y2: "196.116",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_53",
                        x1: "367.614",
                        x2: "397.178",
                        y1: "203.574",
                        y2: "257.897",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_53",
                        x1: "356.03",
                        x2: "366.061",
                        y1: "304.691",
                        y2: "322.544",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_53",
                        x1: "362.065",
                        x2: "336.949",
                        y1: "192.045",
                        y2: "234.964",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_53",
                        x1: "243.718",
                        x2: "385.653",
                        y1: "288.914",
                        y2: "291.709",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_53",
                        x1: "243.427",
                        x2: "385.361",
                        y1: "303.756",
                        y2: "306.552",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_53",
                        x1: "316.65",
                        x2: "301.477",
                        y1: "254.269",
                        y2: "402.889",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_53",
                        x1: "301.747",
                        x2: "217.792",
                        y1: "169.553",
                        y2: "293.419",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_53",
                        x1: "325.826",
                        x2: "274.496",
                        y1: "91.577",
                        y2: "594.303",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_53",
                        x1: "214.344",
                        x2: "198.404",
                        y1: "427.077",
                        y2: "427.077",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_53",
                        x1: "280.436",
                        x2: "260.639",
                        y1: "481.487",
                        y2: "250.045",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_53",
                        x1: "288.404",
                        x2: "262.613",
                        y1: "424.565",
                        y2: "424.565",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_53",
                        x1: "234.209",
                        x2: "214.532",
                        y1: "484.213",
                        y2: "254.158",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_53",
                        x1: "336.704",
                        x2: "317.863",
                        y1: "207.803",
                        y2: "223.507",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_53",
                        x1: "310.928",
                        x2: "223.522",
                        y1: "294.691",
                        y2: "347.326",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_53",
                        x1: "283.462",
                        x2: "279.763",
                        y1: "253.149",
                        y2: "226.077",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_53",
                        x1: "285.314",
                        x2: "289.458",
                        y1: "225.948",
                        y2: "158.749",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_53",
                        x1: "306.918",
                        x2: "185.728",
                        y1: "179.319",
                        y2: "261.746",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_53",
                        x1: "276.456",
                        x2: "280.591",
                        y1: "226.627",
                        y2: "159.527",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_53",
                        x1: "308.614",
                        x2: "343.029",
                        y1: "291.49",
                        y2: "280.939",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_53",
                        x1: "351.931",
                        x2: "330.662",
                        y1: "280.063",
                        y2: "335.828",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_53",
                        x1: "296.227",
                        x2: "272.01",
                        y1: "285.71",
                        y2: "323.999",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_53",
                        x1: "316.074",
                        x2: "301.281",
                        y1: "430.571",
                        y2: "430.501",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_53",
                        x1: "312.036",
                        x2: "304.569",
                        y1: "418.025",
                        y2: "350.087",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_53",
                        x1: "332.537",
                        x2: "317.75",
                        y1: "430.575",
                        y2: "430.506",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_53",
                        x1: "328.501",
                        x2: "321.035",
                        y1: "418.027",
                        y2: "350.09",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_53",
                        x1: "365.84",
                        x2: "294.1",
                        y1: "286.019",
                        y2: "398.227",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_53",
                        x1: "328.694",
                        x2: "321.185",
                        y1: "345.693",
                        y2: "357.562",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint46_linear_0_53",
                        x1: "316.576",
                        x2: "326.805",
                        y1: "335.646",
                        y2: "399.126",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint47_linear_0_53",
                        x1: "320.644",
                        x2: "309.75",
                        y1: "332.658",
                        y2: "291.779",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint48_linear_0_53",
                        x1: "1168.85",
                        x2: "1194.56",
                        y1: "615.416",
                        y2: "625.019",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint49_linear_0_53",
                        x1: "310.161",
                        x2: "335.575",
                        y1: "291.378",
                        y2: "280.674",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint50_linear_0_53",
                        x1: "1167.7",
                        x2: "1193.41",
                        y1: "618.492",
                        y2: "628.095",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint51_linear_0_53",
                        x1: "322.434",
                        x2: "378.077",
                        y1: "164.55",
                        y2: "68.015",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint52_linear_0_53",
                        x1: "345.346",
                        x2: "400.995",
                        y1: "177.758",
                        y2: "81.218",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint53_linear_0_53",
                        x1: "147.089",
                        x2: "217.21",
                        y1: "288.667",
                        y2: "197.067",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint54_linear_0_53",
                        x1: "237.078",
                        x2: "205.675",
                        y1: "282.46",
                        y2: "303.401",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_53",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H437V434H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/whatIsHomeWarranty/style.module.scss
var style_module = __webpack_require__(96025);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsHomeWarranty/index.tsx





function WhatIsHomeWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${(style_module_default()).mainContainer}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:pt-28 pt-14 lg:pb-32 pb-16 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[574px] mx-auto lg:mx-0 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                            children: "What Is a Home Warranty For?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                            children: "A home warranty is a service contract that provides coverage for repairing or replacing major home systems and appliances. It is designed to protect homeowners from unexpected expenses that arise due to the breakdown of essential household items. With a home warranty, homeowners can be at ease knowing that if a covered item malfunctions or stops working, they can contact their warranty provider to arrange for repairs or replacements. This can save homeowners from incurring high repair or replacement costs, providing financial protection and added convenience for their homes."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[300px] h-[250px] md:h-[434px] md:w-[437px] md:min-w-[437px] relative mx-auto lg:mx-0 lg:mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 65984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ S3Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function S3Icon({ image , svgClassName  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: image?.mimeType === "image/svg+xml" && image.imageData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: `children:w-7 children:h-auto children:mx-auto ${svgClassName}`,
            dangerouslySetInnerHTML: {
                __html: image?.imageData
            }
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: `${svgClassName}`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: image?.fullPath,
                alt: image.id
            })
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 82259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"oneBoxStyle":"style_oneBoxStyle___rWnj"};

/***/ }),

/***/ 83083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","mainSection":"styles_mainSection__h2GWu","categories-wrapper":"styles_categories-wrapper__pliqv","category-box":"styles_category-box__l4UKF","category-icon":"styles_category-icon__h5XDU"};

/***/ }),

/***/ 52072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__jZBiM"};

/***/ }),

/***/ 96025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer___ybDu"};

/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);